export const DictionaryIllustrator_fr_FR = [
    {
        id: 18,
        label: 'Edition > Coller devant',
        placement: 'MenuBar',
        name: 'Coller devant',
    },
    {
        id: 19,
        label: 'Edition > Coller derrière',
        placement: 'MenuBar',
        name: 'Coller derrière',
    },
    {
        id: 20,
        label: "Fichier > Nouveau d'après un modèle…",
        placement: 'MenuBar',
        name: "Nouveau d'après un modèle…",
    },
    {
        id: 22,
        label: 'Objet > Transformation > Répéter la transformation',
        placement: 'MenuBar',
        name: 'Répéter la transformation',
    },
    {
        id: 23,
        label: 'Objet > Associer',
        placement: 'MenuBar',
        name: 'Associer',
    },
    {
        id: 24,
        label: 'Objet > Dissocier',
        placement: 'MenuBar',
        name: 'Dissocier',
    },
    {
        id: 25,
        label: 'Objet > Tracé > Joindre',
        placement: 'MenuBar',
        name: 'Joindre',
    },
    {
        id: 26,
        label: 'Objet > Tracé > Alignement...',
        placement: 'MenuBar',
        name: 'Alignement...',
    },
    {
        id: 28,
        label: 'Objet > Verrouiller > Sélection',
        placement: 'MenuBar',
        name: 'Sélection',
    },
    {
        id: 29,
        label: 'Objet > Tout déverrouiller',
        placement: 'MenuBar',
        name: 'Tout déverrouiller',
    },
    {
        id: 30,
        label: 'Affichage > Aperçu',
        placement: 'MenuBar',
        name: 'Aperçu',
    },
    {
        id: 33,
        label: 'Affichage > Aperçu en pixels',
        placement: 'MenuBar',
        name: 'Aperçu en pixels',
    },
    {
        id: 34,
        label: 'Texte > Options de texte captif…',
        placement: 'MenuBar',
        name: 'Options de texte captif…',
    },
    {
        id: 35,
        label: 'Affichage > Ajuster le plan de travail à la fenêtre',
        placement: 'MenuBar',
        name: 'Ajuster le plan de travail à la fenêtre',
    },
    {
        id: 36,
        label: 'Fenêtre > Nouvelle fenêtre',
        placement: 'MenuBar',
        name: 'Nouvelle fenêtre',
    },
    {
        id: 37,
        label: 'Affichage > Règles > Afficher les règles',
        placement: 'MenuBar',
        name: 'Afficher les règles',
    },
    {
        id: 38,
        label: 'Texte > Texte curviligne > Ruban 3D',
        placement: 'MenuBar',
        name: 'Ruban 3D',
    },
    {
        id: 40,
        label: "Texte > Texte curviligne > Marche d'escalier",
        placement: 'MenuBar',
        name: "Marche d'escalier",
    },
    {
        id: 42,
        label: 'Objet > Disposition > Premier plan',
        placement: 'MenuBar',
        name: 'Premier plan',
    },
    {
        id: 43,
        label: 'Objet > Disposition > Arrière-plan',
        placement: 'MenuBar',
        name: 'Arrière-plan',
    },
    {
        id: 48,
        label: 'Fichier > Enregistrer comme modèle…',
        placement: 'MenuBar',
        name: 'Enregistrer comme modèle…',
    },
    {
        id: 50,
        label: 'Objet > Masquer > Sélection',
        placement: 'MenuBar',
        name: 'Sélection',
    },
    {
        id: 51,
        label: 'Objet > Tout afficher',
        placement: 'MenuBar',
        name: 'Tout afficher',
    },
    {
        id: 52,
        label: 'Affichage > Repères > Créer les repères',
        placement: 'MenuBar',
        name: 'Créer les repères',
    },
    {
        id: 53,
        label: 'Affichage > Repères > Annuler les repères',
        placement: 'MenuBar',
        name: 'Annuler les repères',
    },
    {
        id: 54,
        label: 'Objet > Transformation > Déplacement...',
        placement: 'MenuBar',
        name: 'Déplacement...',
    },
    {
        id: 55,
        label: 'Illustrator > Préférences > Repères commentés...',
        placement: 'MenuBar',
        name: 'Repères commentés...',
    },
    {
        id: 56,
        label: 'Objet > Tracé transparent > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 57,
        label: 'Objet > Tracé transparent > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 62,
        label: 'Texte > Vectoriser',
        placement: 'MenuBar',
        name: 'Vectoriser',
    },
    {
        id: 63,
        label: 'Affichage > Taille réelle',
        placement: 'MenuBar',
        name: 'Taille réelle',
    },
    {
        id: 74,
        label: 'Objet > Graphe > Attributs...',
        placement: 'MenuBar',
        name: 'Attributs...',
    },
    {
        id: 75,
        label: 'Objet > Graphe > Données...',
        placement: 'MenuBar',
        name: 'Données...',
    },
    {
        id: 76,
        label: 'Objet > Graphe > Barre...',
        placement: 'MenuBar',
        name: 'Barre...',
    },
    {
        id: 77,
        label: 'Objet > Graphe > Symbole...',
        placement: 'MenuBar',
        name: 'Symbole...',
    },
    {
        id: 78,
        label: 'Objet > Graphe > Point...',
        placement: 'MenuBar',
        name: 'Point...',
    },
    {
        id: 83,
        label: 'Texte > Texte curviligne > Arc-en-ciel',
        placement: 'MenuBar',
        name: 'Arc-en-ciel',
    },
    {
        id: 84,
        label: 'Fichier > Format de document...',
        placement: 'MenuBar',
        name: 'Format de document...',
    },
    {
        id: 85,
        label: "Affichage > Masquer les limites d'impression",
        placement: 'MenuBar',
        name: "Masquer les limites d'impression",
    },
    {
        id: 86,
        label: 'Affichage > Masquer les plans de travail',
        placement: 'MenuBar',
        name: 'Masquer les plans de travail',
    },
    {
        id: 87,
        label: 'Texte > Ajuster en largeur',
        placement: 'MenuBar',
        name: 'Ajuster en largeur',
    },
    {
        id: 95,
        label: 'Fichier > Enregistrer une copie...',
        placement: 'MenuBar',
        name: 'Enregistrer une copie...',
    },
    {
        id: 98,
        label: 'Illustrator > Préférences > Texte...',
        placement: 'MenuBar',
        name: 'Texte...',
    },
    {
        id: 99,
        label: 'Illustrator > Préférences > Unités...',
        placement: 'MenuBar',
        name: 'Unités...',
    },
    {
        id: 100,
        label: 'Objet > Disposition > En avant',
        placement: 'MenuBar',
        name: 'En avant',
    },
    {
        id: 101,
        label: 'Objet > Disposition > En arrière',
        placement: 'MenuBar',
        name: 'En arrière',
    },
    {
        id: 109,
        label: 'Fenêtre > Disposition > Réduire la fenêtre',
        placement: 'MenuBar',
        name: 'Réduire la fenêtre',
    },
    {
        id: 110,
        label: 'Fenêtre > Disposition > Tout au premier plan',
        placement: 'MenuBar',
        name: 'Tout au premier plan',
    },
    {
        id: 113,
        label: 'Affichage > Repères > Effacer les repères',
        placement: 'MenuBar',
        name: 'Effacer les repères',
    },
    {
        id: 114,
        label: 'Affichage > Afficher le modèle',
        placement: 'MenuBar',
        name: 'Afficher le modèle',
    },
    {
        id: 115,
        label: 'Texte > Afficher les caractères masqués',
        placement: 'MenuBar',
        name: 'Afficher les caractères masqués',
    },
    {
        id: 116,
        label: 'Texte > Texte curviligne > Inclinaison',
        placement: 'MenuBar',
        name: 'Inclinaison',
    },
    {
        id: 117,
        label: 'Fichier > Tout fermer',
        placement: 'MenuBar',
        name: 'Tout fermer',
    },
    {
        id: 119,
        label: 'Texte > Texte curviligne > Gravité',
        placement: 'MenuBar',
        name: 'Gravité',
    },
    {
        id: 120,
        label: "Objet > Masque d'écrêtage > Créer",
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 121,
        label: "Objet > Masque d'écrêtage > Annuler",
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 123,
        label: 'Texte > Texte curviligne > Options de texte curviligne…',
        placement: 'MenuBar',
        name: 'Options de texte curviligne…',
    },
    {
        id: 127,
        label: 'Objet > Plans de travail > Convertir en plans de travail',
        placement: 'MenuBar',
        name: 'Convertir en plans de travail',
    },
    {
        id: 133,
        label: 'Texte > Texte lié > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 135,
        label: 'Affichage > Zoom avant',
        placement: 'MenuBar',
        name: 'Zoom avant',
    },
    {
        id: 136,
        label: 'Affichage > Zoom arrière',
        placement: 'MenuBar',
        name: 'Zoom arrière',
    },
    {
        id: 139,
        label: 'Edition > Couleurs...',
        placement: 'MenuBar',
        name: 'Couleurs...',
    },
    {
        id: 140,
        label: 'Illustrator > Préférences > Césure...',
        placement: 'MenuBar',
        name: 'Césure...',
    },
    {
        id: 141,
        label: 'Illustrator > Préférences > Modules externes et disques de travail...',
        placement: 'MenuBar',
        name: 'Modules externes et disques de travail...',
    },
    {
        id: 142,
        label: 'Sélection > Désélectionner',
        placement: 'MenuBar',
        name: 'Désélectionner',
    },
    {
        id: 143,
        label: 'Affichage > Aperçu de la surimpression',
        placement: 'MenuBar',
        name: 'Aperçu de la surimpression',
    },
    {
        id: 144,
        label: 'Affichage > Nouvelle vue...',
        placement: 'MenuBar',
        name: 'Nouvelle vue...',
    },
    {
        id: 145,
        label: 'Affichage > Vues...',
        placement: 'MenuBar',
        name: 'Vues...',
    },
    {
        id: 146,
        label: 'Affichage > Magnétisme du point',
        placement: 'MenuBar',
        name: 'Magnétisme du point',
    },
    {
        id: 147,
        label: 'Affichage > Masquer le contour de sélection',
        placement: 'MenuBar',
        name: 'Masquer le contour de sélection',
    },
    {
        id: 148,
        label: 'Objet > Décomposer l’aspect',
        placement: 'MenuBar',
        name: 'Décomposer l’aspect',
    },
    {
        id: 150,
        label: 'Affichage > Afficher le texte lié',
        placement: 'MenuBar',
        name: 'Afficher le texte lié',
    },
    {
        id: 154,
        label: 'Affichage > Repères > Masquer les repères',
        placement: 'MenuBar',
        name: 'Masquer les repères',
    },
    {
        id: 155,
        label: 'Affichage > Repères > Verrouiller les repères',
        placement: 'MenuBar',
        name: 'Verrouiller les repères',
    },
    {
        id: 157,
        label: 'Texte > Texte lié > Annuler la sélection',
        placement: 'MenuBar',
        name: 'Annuler la sélection',
    },
    {
        id: 158,
        label: 'Texte > Texte lié > Supprimer le lien',
        placement: 'MenuBar',
        name: 'Supprimer le lien',
    },
    {
        id: 159,
        label: 'Affichage > Afficher la grille',
        placement: 'MenuBar',
        name: 'Afficher la grille',
    },
    {
        id: 160,
        label: 'Affichage > Magnétisme de la grille',
        placement: 'MenuBar',
        name: 'Magnétisme de la grille',
    },
    {
        id: 161,
        label: 'Illustrator > Préférences > Repères et grille...',
        placement: 'MenuBar',
        name: 'Repères et grille...',
    },
    {
        id: 162,
        label: 'Objet > Transformation > Rotation...',
        placement: 'MenuBar',
        name: 'Rotation...',
    },
    {
        id: 163,
        label: "Objet > Transformation > Mise à l'échelle...",
        placement: 'MenuBar',
        name: "Mise à l'échelle...",
    },
    {
        id: 164,
        label: 'Objet > Transformation > Miroir...',
        placement: 'MenuBar',
        name: 'Miroir...',
    },
    {
        id: 165,
        label: 'Objet > Transformation > Déformation...',
        placement: 'MenuBar',
        name: 'Déformation...',
    },
    {
        id: 166,
        label: 'Fenêtre > Disposition > Cascade',
        placement: 'MenuBar',
        name: 'Cascade',
    },
    {
        id: 168,
        label: 'Fenêtre > Disposition > Mosaïque',
        placement: 'MenuBar',
        name: 'Mosaïque',
    },
    {
        id: 202,
        label: 'Affichage > Couleurs d’épreuve',
        placement: 'MenuBar',
        name: 'Couleurs d’épreuve',
    },
    {
        id: 203,
        label: 'Edition > Attribuer un profil…',
        placement: 'MenuBar',
        name: 'Attribuer un profil…',
    },
    {
        id: 204,
        label: 'Aide > Didacticiels...',
        placement: 'MenuBar',
        name: 'Didacticiels...',
    },
    {
        id: 223,
        label: 'Fichier > Mode colorimétrique du document > Couleurs CMJN',
        placement: 'MenuBar',
        name: 'Couleurs CMJN',
    },
    {
        id: 224,
        label: 'Fichier > Mode colorimétrique du document > Couleurs RVB',
        placement: 'MenuBar',
        name: 'Couleurs RVB',
    },
    {
        id: 225,
        label: "Affichage > Format d'épreuve > Espace CMJN du document :",
        placement: 'MenuBar',
        name: 'Espace CMJN du document :',
    },
    {
        id: 226,
        label: "Affichage > Format d'épreuve > RVB Macintosh hérité (Gamma 1.8)",
        placement: 'MenuBar',
        name: 'RVB Macintosh hérité (Gamma 1.8)',
    },
    {
        id: 227,
        label: "Affichage > Format d'épreuve > RVB Internet standard (sRGB)",
        placement: 'MenuBar',
        name: 'RVB Internet standard (sRGB)',
    },
    {
        id: 228,
        label: "Affichage > Format d'épreuve > RVB Moniteur",
        placement: 'MenuBar',
        name: 'RVB Moniteur',
    },
    {
        id: 229,
        label: 'Texte > Orientation du texte > Horizontale',
        placement: 'MenuBar',
        name: 'Horizontale',
    },
    {
        id: 230,
        label: 'Texte > Orientation du texte > Verticale',
        placement: 'MenuBar',
        name: 'Verticale',
    },
    {
        id: 232,
        label: 'Aide > Informations sur le système…',
        placement: 'MenuBar',
        name: 'Informations sur le système…',
    },
    {
        id: 278,
        label: 'Texte > Texte hérité > Mettre à jour le texte hérité',
        placement: 'MenuBar',
        name: 'Mettre à jour le texte hérité',
    },
    {
        id: 279,
        label: 'Texte > Texte hérité > Mettre à jour le texte hérité sélectionné',
        placement: 'MenuBar',
        name: 'Mettre à jour le texte hérité sélectionné',
    },
    {
        id: 280,
        label: 'Texte > Texte hérité > Masquer les copies',
        placement: 'MenuBar',
        name: 'Masquer les copies',
    },
    {
        id: 281,
        label: 'Texte > Texte hérité > Effacer les copies',
        placement: 'MenuBar',
        name: 'Effacer les copies',
    },
    {
        id: 282,
        label: 'Texte > Texte hérité > Sélectionner les copies',
        placement: 'MenuBar',
        name: 'Sélectionner les copies',
    },
    {
        id: 284,
        label: "Affichage > Format d'épreuve > Personnaliser...",
        placement: 'MenuBar',
        name: 'Personnaliser...',
    },
    {
        id: 289,
        label: "Illustrator > Préférences > Sélection et affichage des points d'ancrage...",
        placement: 'MenuBar',
        name: "Sélection et affichage des points d'ancrage...",
    },
    {
        id: 292,
        label: "Objet > Masque d'écrêtage > Modifier le contenu",
        placement: 'MenuBar',
        name: 'Modifier le contenu',
    },
    {
        id: 293,
        label: 'Illustrator > Préférences > Interface utilisateur...',
        placement: 'MenuBar',
        name: 'Interface utilisateur...',
    },
    {
        id: 294,
        label: 'Illustrator > Préférences > Tranches...',
        placement: 'MenuBar',
        name: 'Tranches...',
    },
    {
        id: 295,
        label: "Fenêtre > Cadre de l'application",
        placement: 'MenuBar',
        name: "Cadre de l'application",
    },
    {
        id: 296,
        label: "Affichage > Format d'épreuve > Daltonisme - Protanopie",
        placement: 'MenuBar',
        name: 'Daltonisme - Protanopie',
    },
    {
        id: 297,
        label: "Affichage > Format d'épreuve > Daltonisme - Deutéranopie",
        placement: 'MenuBar',
        name: 'Daltonisme - Deutéranopie',
    },
    {
        id: 299,
        label: 'Affichage > Règles > Afficher les règles vidéo',
        placement: 'MenuBar',
        name: 'Afficher les règles vidéo',
    },
    {
        id: 301,
        label: 'Fenêtre > Disposition > Faire flotter dans la fenêtre',
        placement: 'MenuBar',
        name: 'Faire flotter dans la fenêtre',
    },
    {
        id: 302,
        label: 'Fenêtre > Disposition > Tout faire flotter dans les fenêtres',
        placement: 'MenuBar',
        name: 'Tout faire flotter dans les fenêtres',
    },
    {
        id: 303,
        label: 'Fenêtre > Disposition > Intégrer toutes les fenêtres',
        placement: 'MenuBar',
        name: 'Intégrer toutes les fenêtres',
    },
    {
        id: 304,
        label: "Fenêtre > Barre de l'application",
        placement: 'MenuBar',
        name: "Barre de l'application",
    },
    {
        id: 310,
        label: 'Texte > Texte curviligne > Mettre à jour le texte curviligne hérité',
        placement: 'MenuBar',
        name: 'Mettre à jour le texte curviligne hérité',
    },
    {
        id: 311,
        label: 'Affichage > Tout ajuster à la fenêtre',
        placement: 'MenuBar',
        name: 'Tout ajuster à la fenêtre',
    },
    {
        id: 315,
        label: 'Edition > Coller sur place',
        placement: 'MenuBar',
        name: 'Coller sur place',
    },
    {
        id: 316,
        label: 'Edition > Coller dans tous les plans de travail',
        placement: 'MenuBar',
        name: 'Coller dans tous les plans de travail',
    },
    {
        id: 331,
        label: 'Texte > Conversion de type de texte',
        placement: 'MenuBar',
        name: 'Conversion de type de texte',
    },
    {
        id: 339,
        label: 'Edition > Mes paramètres > Exporter les paramètres...',
        placement: 'MenuBar',
        name: 'Exporter les paramètres...',
    },
    {
        id: 340,
        label: 'Edition > Mes paramètres > Importer les paramètres...',
        placement: 'MenuBar',
        name: 'Importer les paramètres...',
    },
    {
        id: 347,
        label: 'Affichage > Afficher avec GPU',
        placement: 'MenuBar',
        name: 'Afficher avec GPU',
    },
    {
        id: 351,
        label: 'Fichier > Exporter la sélection...',
        placement: 'MenuBar',
        name: 'Exporter la sélection...',
    },
    {
        id: 353,
        label: 'Affichage > Magnétisme du pixel',
        placement: 'MenuBar',
        name: 'Magnétisme du pixel',
    },
    {
        id: 354,
        label: 'Fichier > Exporter > Exporter pour les écrans...',
        placement: 'MenuBar',
        name: 'Exporter pour les écrans...',
    },
    {
        id: 355,
        label: 'Fichier > Exporter > Exporter sous...',
        placement: 'MenuBar',
        name: 'Exporter sous...',
    },
    {
        id: 356,
        label: 'Fichier > Exporter > Enregistrer pour le web (hérité)...',
        placement: 'MenuBar',
        name: 'Enregistrer pour le web (hérité)...',
    },
    {
        id: 368,
        label: 'Texte > Insérer un caractère spécial > Symboles > Puce',
        placement: 'MenuBar',
        name: 'Puce',
    },
    {
        id: 369,
        label: 'Texte > Insérer un caractère spécial > Symboles > Symbole de copyright',
        placement: 'MenuBar',
        name: 'Symbole de copyright',
    },
    {
        id: 370,
        label: 'Texte > Insérer un caractère spécial > Symboles > Points de suspension',
        placement: 'MenuBar',
        name: 'Points de suspension',
    },
    {
        id: 371,
        label: 'Texte > Insérer un caractère spécial > Symboles > Marque de paragraphe',
        placement: 'MenuBar',
        name: 'Marque de paragraphe',
    },
    {
        id: 372,
        label: 'Texte > Insérer un caractère spécial > Symboles > Symbole de marque déposée',
        placement: 'MenuBar',
        name: 'Symbole de marque déposée',
    },
    {
        id: 373,
        label: 'Texte > Insérer un caractère spécial > Symboles > Symbole de section',
        placement: 'MenuBar',
        name: 'Symbole de section',
    },
    {
        id: 374,
        label: 'Texte > Insérer un caractère spécial > Symboles > Symbole de marque commerciale',
        placement: 'MenuBar',
        name: 'Symbole de marque commerciale',
    },
    {
        id: 375,
        label: 'Texte > Insérer un caractère spécial > Guillemets > Guillemets anglais ouvrants',
        placement: 'MenuBar',
        name: 'Guillemets anglais ouvrants',
    },
    {
        id: 376,
        label: 'Texte > Insérer un caractère spécial > Guillemets > Guillemets anglais fermants',
        placement: 'MenuBar',
        name: 'Guillemets anglais fermants',
    },
    {
        id: 377,
        label: 'Texte > Insérer un caractère spécial > Guillemets > Guillemets allemands ouvrants',
        placement: 'MenuBar',
        name: 'Guillemets allemands ouvrants',
    },
    {
        id: 378,
        label: 'Texte > Insérer un caractère spécial > Guillemets > Guillemets allemands fermants',
        placement: 'MenuBar',
        name: 'Guillemets allemands fermants',
    },
    {
        id: 379,
        label: 'Texte > Insérer un caractère spécial > Césures et tirets > Tiret cadratin',
        placement: 'MenuBar',
        name: 'Tiret cadratin',
    },
    {
        id: 380,
        label: 'Texte > Insérer un caractère spécial > Césures et tirets > Tiret demi-cadratin',
        placement: 'MenuBar',
        name: 'Tiret demi-cadratin',
    },
    {
        id: 381,
        label: 'Texte > Insérer un caractère spécial > Césures et tirets > Tiret conditionnel',
        placement: 'MenuBar',
        name: 'Tiret conditionnel',
    },
    {
        id: 382,
        label: 'Texte > Insérer une espace > Espace cadratin',
        placement: 'MenuBar',
        name: 'Espace cadratin',
    },
    {
        id: 383,
        label: 'Texte > Insérer une espace > Espace demi-cadratin',
        placement: 'MenuBar',
        name: 'Espace demi-cadratin',
    },
    {
        id: 384,
        label: 'Texte > Insérer une espace > Espace ultrafine',
        placement: 'MenuBar',
        name: 'Espace ultrafine',
    },
    {
        id: 385,
        label: 'Texte > Insérer une espace > Espace fine',
        placement: 'MenuBar',
        name: 'Espace fine',
    },
    {
        id: 386,
        label: 'Texte > Insérer un caractère de saut > Saut de ligne forcé',
        placement: 'MenuBar',
        name: 'Saut de ligne forcé',
    },
    {
        id: 391,
        label: 'Texte > Remplir avec le texte de substitution',
        placement: 'MenuBar',
        name: 'Remplir avec le texte de substitution',
    },
    {
        id: 393,
        label: "Objet > Collecter pour l'exportation > En tant que fichier unique",
        placement: 'MenuBar',
        name: 'En tant que fichier unique',
    },
    {
        id: 394,
        label: "Objet > Collecter pour l'exportation > En tant que plusieurs fichiers",
        placement: 'MenuBar',
        name: 'En tant que plusieurs fichiers',
    },
    {
        id: 396,
        label: 'Affichage > Affichage rogné',
        placement: 'MenuBar',
        name: 'Affichage rogné',
    },
    {
        id: 397,
        label: 'Affichage > Mode Présentation',
        placement: 'MenuBar',
        name: 'Mode Présentation',
    },
    {
        id: 404,
        label: "Affichage > Mode de l'écran > Mode Ecran normal",
        placement: 'MenuBar',
        name: 'Mode Ecran normal',
    },
    {
        id: 405,
        label: "Affichage > Mode de l'écran > Mode Plein écran avec mode Barre de menus",
        placement: 'MenuBar',
        name: 'Mode Plein écran avec mode Barre de menus',
    },
    {
        id: 406,
        label: "Affichage > Mode de l'écran > Mode Plein écran sans menus",
        placement: 'MenuBar',
        name: 'Mode Plein écran sans menus',
    },
    {
        id: 411,
        label: 'Affichage > Accrocher au glyphe',
        placement: 'MenuBar',
        name: 'Accrocher au glyphe',
    },
    {
        id: 415,
        label: 'Affichage > Faire pivoter l’affichage vers la sélection',
        placement: 'MenuBar',
        name: 'Faire pivoter l’affichage vers la sélection',
    },
    {
        id: 417,
        label: 'Affichage > Faire pivoter l’affichage > 180',
        placement: 'MenuBar',
        name: '180',
    },
    {
        id: 418,
        label: 'Affichage > Faire pivoter l’affichage > 150',
        placement: 'MenuBar',
        name: '150',
    },
    {
        id: 419,
        label: 'Affichage > Faire pivoter l’affichage > 135',
        placement: 'MenuBar',
        name: '135',
    },
    {
        id: 420,
        label: 'Affichage > Faire pivoter l’affichage > 120',
        placement: 'MenuBar',
        name: '120',
    },
    {
        id: 421,
        label: 'Affichage > Faire pivoter l’affichage > 90',
        placement: 'MenuBar',
        name: '90',
    },
    {
        id: 422,
        label: 'Affichage > Faire pivoter l’affichage > 60',
        placement: 'MenuBar',
        name: '60',
    },
    {
        id: 423,
        label: 'Affichage > Faire pivoter l’affichage > 45',
        placement: 'MenuBar',
        name: '45',
    },
    {
        id: 424,
        label: 'Affichage > Faire pivoter l’affichage > 30',
        placement: 'MenuBar',
        name: '30',
    },
    {
        id: 425,
        label: 'Affichage > Faire pivoter l’affichage > 15',
        placement: 'MenuBar',
        name: '15',
    },
    {
        id: 426,
        label: 'Affichage > Faire pivoter l’affichage > 0',
        placement: 'MenuBar',
        name: '0',
    },
    {
        id: 427,
        label: 'Affichage > Faire pivoter l’affichage > -15',
        placement: 'MenuBar',
        name: '-15',
    },
    {
        id: 428,
        label: 'Affichage > Faire pivoter l’affichage > -30',
        placement: 'MenuBar',
        name: '-30',
    },
    {
        id: 429,
        label: 'Affichage > Faire pivoter l’affichage > -45',
        placement: 'MenuBar',
        name: '-45',
    },
    {
        id: 430,
        label: 'Affichage > Faire pivoter l’affichage > -60',
        placement: 'MenuBar',
        name: '-60',
    },
    {
        id: 431,
        label: 'Affichage > Faire pivoter l’affichage > -90',
        placement: 'MenuBar',
        name: '-90',
    },
    {
        id: 432,
        label: 'Affichage > Faire pivoter l’affichage > -120',
        placement: 'MenuBar',
        name: '-120',
    },
    {
        id: 433,
        label: 'Affichage > Faire pivoter l’affichage > -135',
        placement: 'MenuBar',
        name: '-135',
    },
    {
        id: 434,
        label: 'Affichage > Faire pivoter l’affichage > -150',
        placement: 'MenuBar',
        name: '-150',
    },
    {
        id: 435,
        label: 'Affichage > Faire pivoter l’affichage > -180',
        placement: 'MenuBar',
        name: '-180',
    },
    {
        id: 436,
        label: 'Affichage > Réinitialiser la rotation de l’affichage',
        placement: 'MenuBar',
        name: 'Réinitialiser la rotation de l’affichage',
    },
    {
        id: 437,
        label: 'Edition > Coller sans mise en forme',
        placement: 'MenuBar',
        name: 'Coller sans mise en forme',
    },
    {
        id: 438,
        label: 'Aide > Nouveautés...',
        placement: 'MenuBar',
        name: 'Nouveautés...',
    },
    {
        id: 440,
        label: 'Texte > Puces et numérotation > Appliquer des puces',
        placement: 'MenuBar',
        name: 'Appliquer des puces',
    },
    {
        id: 441,
        label: 'Texte > Puces et numérotation > Appliquer des numéros',
        placement: 'MenuBar',
        name: 'Appliquer des numéros',
    },
    {
        id: 448,
        label: 'Texte > Puces et numérotation > Convertir en texte',
        placement: 'MenuBar',
        name: 'Convertir en texte',
    },
    {
        id: 456,
        label: 'Texte > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 471,
        label: 'Objet > Tout dissocier',
        placement: 'MenuBar',
        name: 'Tout dissocier',
    },
    {
        id: 472,
        label: 'Texte > Insérer une espace > Espace insécable',
        placement: 'MenuBar',
        name: 'Espace insécable',
    },
    {
        id: 1383427079,
        label: 'Affichage > Règles > Passer aux règles du plan de travail',
        placement: 'MenuBar',
        name: 'Passer aux règles du plan de travail',
    },
    {
        id: 1633841013,
        label: "Illustrator > A propos d'lllustrator...",
        placement: 'MenuBar',
        name: "A propos d'lllustrator...",
    },
    {
        id: 1634233456,
        label: 'Aide > Aide d’Illustrator...',
        placement: 'MenuBar',
        name: 'Aide d’Illustrator...',
    },
    {
        id: 1634296684,
        label: 'Fichier > Fermer',
        placement: 'MenuBar',
        name: 'Fermer',
    },
    {
        id: 1668048225,
        label: 'Edition > Effacer',
        placement: 'MenuBar',
        name: 'Effacer',
    },
    {
        id: 1668247673,
        label: 'Edition > Copier',
        placement: 'MenuBar',
        name: 'Copier',
    },
    {
        id: 1668641824,
        label: 'Edition > Couper',
        placement: 'MenuBar',
        name: 'Couper',
    },
    {
        id: 1751737445,
        label: 'Illustrator > Masquer Illustrator',
        placement: 'MenuBar',
        name: 'Masquer Illustrator',
    },
    {
        id: 1751737455,
        label: 'Illustrator > Masquer les autres',
        placement: 'MenuBar',
        name: 'Masquer les autres',
    },
    {
        id: 1852143392,
        label: 'Fichier > Nouveau...',
        placement: 'MenuBar',
        name: 'Nouveau...',
    },
    {
        id: 1869636974,
        label: 'Fichier > Ouvrir...',
        placement: 'MenuBar',
        name: 'Ouvrir...',
    },
    {
        id: 1885434740,
        label: 'Edition > Coller',
        placement: 'MenuBar',
        name: 'Coller',
    },
    {
        id: 1886545254,
        label: 'Illustrator > Préférences > Général...',
        placement: 'MenuBar',
        name: 'Général...',
    },
    {
        id: 1903520116,
        label: 'Illustrator > Quitter Illustrator',
        placement: 'MenuBar',
        name: 'Quitter Illustrator',
    },
    {
        id: 1919247471,
        label: 'Edition > Rétablir',
        placement: 'MenuBar',
        name: 'Rétablir',
    },
    {
        id: 1920365172,
        label: 'Fichier > Version précédente',
        placement: 'MenuBar',
        name: 'Version précédente',
    },
    {
        id: 1934727834,
        label: 'Sélection > Tout sur le plan de travail actif',
        placement: 'MenuBar',
        name: 'Tout sur le plan de travail actif',
    },
    {
        id: 1935764588,
        label: 'Sélection > Tout',
        placement: 'MenuBar',
        name: 'Tout',
    },
    {
        id: 1935767141,
        label: 'Fichier > Enregistrer',
        placement: 'MenuBar',
        name: 'Enregistrer',
    },
    {
        id: 1936220524,
        label: 'Illustrator > Tout afficher',
        placement: 'MenuBar',
        name: 'Tout afficher',
    },
    {
        id: 1936292352,
        label: 'Texte > Corps > 6 pt',
        placement: 'MenuBar',
        name: '6 pt',
    },
    {
        id: 1936292353,
        label: 'Texte > Corps > 7 pt',
        placement: 'MenuBar',
        name: '7 pt',
    },
    {
        id: 1936292354,
        label: 'Texte > Corps > 8 pt',
        placement: 'MenuBar',
        name: '8 pt',
    },
    {
        id: 1936292355,
        label: 'Texte > Corps > 9 pt',
        placement: 'MenuBar',
        name: '9 pt',
    },
    {
        id: 1936292356,
        label: 'Texte > Corps > 10 pt',
        placement: 'MenuBar',
        name: '10 pt',
    },
    {
        id: 1936292357,
        label: 'Texte > Corps > 11 pt',
        placement: 'MenuBar',
        name: '11 pt',
    },
    {
        id: 1936292358,
        label: 'Texte > Corps > 12 pt',
        placement: 'MenuBar',
        name: '12 pt',
    },
    {
        id: 1936292359,
        label: 'Texte > Corps > 14 pt',
        placement: 'MenuBar',
        name: '14 pt',
    },
    {
        id: 1936292360,
        label: 'Texte > Corps > 18 pt',
        placement: 'MenuBar',
        name: '18 pt',
    },
    {
        id: 1936292361,
        label: 'Texte > Corps > 21 pt',
        placement: 'MenuBar',
        name: '21 pt',
    },
    {
        id: 1936292362,
        label: 'Texte > Corps > 24 pt',
        placement: 'MenuBar',
        name: '24 pt',
    },
    {
        id: 1936292363,
        label: 'Texte > Corps > 36 pt',
        placement: 'MenuBar',
        name: '36 pt',
    },
    {
        id: 1936292364,
        label: 'Texte > Corps > 48 pt',
        placement: 'MenuBar',
        name: '48 pt',
    },
    {
        id: 1936292365,
        label: 'Texte > Corps > 60 pt',
        placement: 'MenuBar',
        name: '60 pt',
    },
    {
        id: 1936292366,
        label: 'Texte > Corps > 72 pt',
        placement: 'MenuBar',
        name: '72 pt',
    },
    {
        id: 1936292367,
        label: 'Texte > Corps > Autre...',
        placement: 'MenuBar',
        name: 'Autre...',
    },
    {
        id: 1937138035,
        label: 'Fichier > Enregistrer sous...',
        placement: 'MenuBar',
        name: 'Enregistrer sous...',
    },
    {
        id: 1970168943,
        label: 'Edition > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164260867,
        label: 'Aide > Gérer mon compte...',
        placement: 'MenuBar',
        name: 'Gérer mon compte...',
    },
    {
        id: 2164260869,
        label: 'Aide > Mises à jour...',
        placement: 'MenuBar',
        name: 'Mises à jour...',
    },
    {
        id: 2164260870,
        label: "Effet > Appliquer l'effet précédent",
        placement: 'MenuBar',
        name: "Appliquer l'effet précédent",
    },
    {
        id: 2164260871,
        label: 'Effet > Effet précédent',
        placement: 'MenuBar',
        name: 'Effet précédent',
    },
    {
        id: 2164260872,
        label: 'Fichier > Rechercher dans Adobe Stock...',
        placement: 'MenuBar',
        name: 'Rechercher dans Adobe Stock...',
    },
    {
        id: 2164260873,
        label: 'Fichier > Importer...',
        placement: 'MenuBar',
        name: 'Importer...',
    },
    {
        id: 2164260874,
        label: "Objet > Tracé > Supprimer les points d'ancrage",
        placement: 'MenuBar',
        name: "Supprimer les points d'ancrage",
    },
    {
        id: 2164260877,
        label: 'Aide > Debug > Memory Use Checkpoint',
        placement: 'MenuBar',
        name: 'Memory Use Checkpoint',
    },
    {
        id: 2164260878,
        label: 'Aide > Debug > Save Memory Use',
        placement: 'MenuBar',
        name: 'Save Memory Use',
    },
    {
        id: 2164260880,
        label: 'Aide > Debug > Progress: Bar Shown',
        placement: 'MenuBar',
        name: 'Progress: Bar Shown',
    },
    {
        id: 2164260881,
        label: 'Aide > Debug > Progress: Tight loop for 120 Seconds',
        placement: 'MenuBar',
        name: 'Progress: Tight loop for 120 Seconds',
    },
    {
        id: 2164260882,
        label: 'Aide > Debug > Responsive Rate Test',
        placement: 'MenuBar',
        name: 'Responsive Rate Test',
    },
    {
        id: 2164260883,
        label: 'Aide > Debug > Test Notification 1',
        placement: 'MenuBar',
        name: 'Test Notification 1',
    },
    {
        id: 2164260884,
        label: 'Aide > Debug > Test Notification 2',
        placement: 'MenuBar',
        name: 'Test Notification 2',
    },
    {
        id: 2164260885,
        label: 'Aide > Debug > Test Notification 3',
        placement: 'MenuBar',
        name: 'Test Notification 3',
    },
    {
        id: 2164260887,
        label: 'Aide > Debug > Count Objects',
        placement: 'MenuBar',
        name: 'Count Objects',
    },
    {
        id: 2164260888,
        label: 'Aide > Debug > Object Counts',
        placement: 'MenuBar',
        name: 'Object Counts',
    },
    {
        id: 2164260890,
        label: 'Aide > Debug > Track API Refs',
        placement: 'MenuBar',
        name: 'Track API Refs',
    },
    {
        id: 2164260891,
        label: 'Aide > Debug > Process Deep Link',
        placement: 'MenuBar',
        name: 'Process Deep Link',
    },
    {
        id: 2164260892,
        label: 'Aide > Debug > Start Discover Panel Tour',
        placement: 'MenuBar',
        name: 'Start Discover Panel Tour',
    },
    {
        id: 2164260894,
        label: 'Aide > Debug > Enable New Rendering',
        placement: 'MenuBar',
        name: 'Enable New Rendering',
    },
    {
        id: 2164260895,
        label: 'Aide > Debug > Enable Rendering Timer',
        placement: 'MenuBar',
        name: 'Enable Rendering Timer',
    },
    {
        id: 2164260896,
        label: 'Aide > Debug > Purge Rendering Cache',
        placement: 'MenuBar',
        name: 'Purge Rendering Cache',
    },
    {
        id: 2164260897,
        label: 'Aide > Debug > Redraw',
        placement: 'MenuBar',
        name: 'Redraw',
    },
    {
        id: 2164260898,
        label: 'Aide > Debug > Dump Application Heap Used',
        placement: 'MenuBar',
        name: 'Dump Application Heap Used',
    },
    {
        id: 2164260899,
        label: 'Aide > Debug > Disable Greeking for New Rendering',
        placement: 'MenuBar',
        name: 'Disable Greeking for New Rendering',
    },
    {
        id: 2164260900,
        label: 'Aide > Debug > Enable Threaded Rendering',
        placement: 'MenuBar',
        name: 'Enable Threaded Rendering',
    },
    {
        id: 2164260901,
        label: 'Aide > Debug > Enable AGM Threading',
        placement: 'MenuBar',
        name: 'Enable AGM Threading',
    },
    {
        id: 2164260902,
        label: 'Aide > Debug > Enable AGM Internal Memory Pool',
        placement: 'MenuBar',
        name: 'Enable AGM Internal Memory Pool',
    },
    {
        id: 2164260903,
        label: 'Aide > Debug > Enable QuickPort Quartz',
        placement: 'MenuBar',
        name: 'Enable QuickPort Quartz',
    },
    {
        id: 2164260904,
        label: 'Aide > Debug > Crash',
        placement: 'MenuBar',
        name: 'Crash',
    },
    {
        id: 2164260906,
        label: 'Aide > Debug > Enable PGF Recovery',
        placement: 'MenuBar',
        name: 'Enable PGF Recovery',
    },
    {
        id: 2164260907,
        label: 'Aide > Debug > Enable ATE Read Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Read Recovery',
    },
    {
        id: 2164260908,
        label: 'Aide > Debug > Enable ATE Write Recovery',
        placement: 'MenuBar',
        name: 'Enable ATE Write Recovery',
    },
    {
        id: 2164260910,
        label: 'Fenêtre > Infos',
        placement: 'MenuBar',
        name: 'Infos',
    },
    {
        id: 2164260912,
        label: 'Fenêtre > Texte > Caractère',
        placement: 'MenuBar',
        name: 'Caractère',
    },
    {
        id: 2164260913,
        label: 'Fenêtre > Texte > Paragraphe',
        placement: 'MenuBar',
        name: 'Paragraphe',
    },
    {
        id: 2164260914,
        label: 'Fenêtre > Texte > Tabulations',
        placement: 'MenuBar',
        name: 'Tabulations',
    },
    {
        id: 2164260915,
        label: 'Fenêtre > Texte > OpenType',
        placement: 'MenuBar',
        name: 'OpenType',
    },
    {
        id: 2164260916,
        label: 'Effet > Effets Photoshop',
        placement: 'MenuBar',
        name: 'Effets Photoshop',
    },
    {
        id: 2164260919,
        label: 'Effet > Atténuation > Flou optimisé...',
        placement: 'MenuBar',
        name: 'Flou optimisé...',
    },
    {
        id: 2164260920,
        label: 'Effet > Atténuation > Flou radial...',
        placement: 'MenuBar',
        name: 'Flou radial...',
    },
    {
        id: 2164260922,
        label: 'Effet > Pixellisation > Pointillisme...',
        placement: 'MenuBar',
        name: 'Pointillisme...',
    },
    {
        id: 2164260923,
        label: 'Effet > Pixellisation > Mezzo-tinto...',
        placement: 'MenuBar',
        name: 'Mezzo-tinto...',
    },
    {
        id: 2164260925,
        label: 'Effet > Vidéo > Désentrelacement...',
        placement: 'MenuBar',
        name: 'Désentrelacement...',
    },
    {
        id: 2164260926,
        label: 'Effet > Pixellisation > Cristallisation...',
        placement: 'MenuBar',
        name: 'Cristallisation...',
    },
    {
        id: 2164260927,
        label: 'Effet > Pixellisation > Demi-teintes couleur...',
        placement: 'MenuBar',
        name: 'Demi-teintes couleur...',
    },
    {
        id: 2164260928,
        label: 'Effet > Vidéo > Couleurs NTSC',
        placement: 'MenuBar',
        name: 'Couleurs NTSC',
    },
    {
        id: 2164260930,
        label: 'Effet > Artistiques > Aquarelle...',
        placement: 'MenuBar',
        name: 'Aquarelle...',
    },
    {
        id: 2164260932,
        label: 'Effet > Esquisse > Papier humide...',
        placement: 'MenuBar',
        name: 'Papier humide...',
    },
    {
        id: 2164260933,
        label: 'Effet > Artistiques > Sous-couche...',
        placement: 'MenuBar',
        name: 'Sous-couche...',
    },
    {
        id: 2164260934,
        label: 'Effet > Esquisse > Contour déchiré...',
        placement: 'MenuBar',
        name: 'Contour déchiré...',
    },
    {
        id: 2164260936,
        label: 'Effet > Textures > Placage de texture...',
        placement: 'MenuBar',
        name: 'Placage de texture...',
    },
    {
        id: 2164260938,
        label: 'Effet > Contours > Sumi-e...',
        placement: 'MenuBar',
        name: 'Sumi-e...',
    },
    {
        id: 2164260939,
        label: 'Effet > Esquisse > Tampon...',
        placement: 'MenuBar',
        name: 'Tampon...',
    },
    {
        id: 2164260940,
        label: 'Effet > Textures > Vitrail...',
        placement: 'MenuBar',
        name: 'Vitrail...',
    },
    {
        id: 2164260941,
        label: 'Effet > Contours > Aérographe...',
        placement: 'MenuBar',
        name: 'Aérographe...',
    },
    {
        id: 2164260942,
        label: 'Effet > Artistiques > Eponge...',
        placement: 'MenuBar',
        name: 'Eponge...',
    },
    {
        id: 2164260943,
        label: 'Effet > Contours > Effet pointilliste...',
        placement: 'MenuBar',
        name: 'Effet pointilliste...',
    },
    {
        id: 2164260944,
        label: 'Effet > Artistiques > Etalement...',
        placement: 'MenuBar',
        name: 'Etalement...',
    },
    {
        id: 2164260945,
        label: 'Effet > Artistiques > Pastels...',
        placement: 'MenuBar',
        name: 'Pastels...',
    },
    {
        id: 2164260946,
        label: 'Effet > Esquisse > Réticulation...',
        placement: 'MenuBar',
        name: 'Réticulation...',
    },
    {
        id: 2164260947,
        label: 'Effet > Artistiques > Contour postérisé...',
        placement: 'MenuBar',
        name: 'Contour postérisé...',
    },
    {
        id: 2164260948,
        label: 'Effet > Artistiques > Emballage plastique...',
        placement: 'MenuBar',
        name: 'Emballage plastique...',
    },
    {
        id: 2164260949,
        label: 'Effet > Esquisse > Plâtre...',
        placement: 'MenuBar',
        name: 'Plâtre...',
    },
    {
        id: 2164260950,
        label: 'Effet > Esquisse > Photocopie...',
        placement: 'MenuBar',
        name: 'Photocopie...',
    },
    {
        id: 2164260951,
        label: 'Effet > Textures > Patchwork...',
        placement: 'MenuBar',
        name: 'Patchwork...',
    },
    {
        id: 2164260952,
        label: 'Effet > Artistiques > Couteau à palette...',
        placement: 'MenuBar',
        name: 'Couteau à palette...',
    },
    {
        id: 2164260953,
        label: 'Effet > Artistiques > Barbouillage...',
        placement: 'MenuBar',
        name: 'Barbouillage...',
    },
    {
        id: 2164260955,
        label: 'Effet > Déformation > Océan...',
        placement: 'MenuBar',
        name: 'Océan...',
    },
    {
        id: 2164260956,
        label: 'Effet > Esquisse > Papier gaufré...',
        placement: 'MenuBar',
        name: 'Papier gaufré...',
    },
    {
        id: 2164260957,
        label: 'Effet > Artistiques > Néon...',
        placement: 'MenuBar',
        name: 'Néon...',
    },
    {
        id: 2164260958,
        label: 'Effet > Textures > Effet mosaïque...',
        placement: 'MenuBar',
        name: 'Effet mosaïque...',
    },
    {
        id: 2164260959,
        label: 'Effet > Contours > Contour encré...',
        placement: 'MenuBar',
        name: 'Contour encré...',
    },
    {
        id: 2164260960,
        label: 'Effet > Esquisse > Trame de demi-teintes...',
        placement: 'MenuBar',
        name: 'Trame de demi-teintes...',
    },
    {
        id: 2164260961,
        label: 'Effet > Esquisse > Plume calligraphique...',
        placement: 'MenuBar',
        name: 'Plume calligraphique...',
    },
    {
        id: 2164260962,
        label: 'Effet > Textures > Grain...',
        placement: 'MenuBar',
        name: 'Grain...',
    },
    {
        id: 2164260964,
        label: 'Effet > Esthétiques > Contour lumineux...',
        placement: 'MenuBar',
        name: 'Contour lumineux...',
    },
    {
        id: 2164260965,
        label: 'Effet > Déformation > Verre...',
        placement: 'MenuBar',
        name: 'Verre...',
    },
    {
        id: 2164260966,
        label: 'Effet > Artistiques > Fresque...',
        placement: 'MenuBar',
        name: 'Fresque...',
    },
    {
        id: 2164260967,
        label: 'Effet > Artistiques > Grain photo...',
        placement: 'MenuBar',
        name: 'Grain photo...',
    },
    {
        id: 2164260968,
        label: 'Effet > Artistiques > Pinceau à sec...',
        placement: 'MenuBar',
        name: 'Pinceau à sec...',
    },
    {
        id: 2164260969,
        label: 'Effet > Déformation > Lueur diffuse...',
        placement: 'MenuBar',
        name: 'Lueur diffuse...',
    },
    {
        id: 2164260970,
        label: 'Effet > Contours > Noir/Blanc...',
        placement: 'MenuBar',
        name: 'Noir/Blanc...',
    },
    {
        id: 2164260971,
        label: 'Effet > Artistiques > Découpage...',
        placement: 'MenuBar',
        name: 'Découpage...',
    },
    {
        id: 2164260972,
        label: 'Effet > Contours > Croisillons...',
        placement: 'MenuBar',
        name: 'Croisillons...',
    },
    {
        id: 2164260973,
        label: 'Effet > Textures > Craquelure...',
        placement: 'MenuBar',
        name: 'Craquelure...',
    },
    {
        id: 2164260974,
        label: 'Effet > Esquisse > Crayon Conté...',
        placement: 'MenuBar',
        name: 'Crayon Conté...',
    },
    {
        id: 2164260975,
        label: 'Effet > Artistiques > Crayon de couleur...',
        placement: 'MenuBar',
        name: 'Crayon de couleur...',
    },
    {
        id: 2164260976,
        label: 'Effet > Esquisse > Chrome...',
        placement: 'MenuBar',
        name: 'Chrome...',
    },
    {
        id: 2164260977,
        label: 'Effet > Esquisse > Fusain...',
        placement: 'MenuBar',
        name: 'Fusain...',
    },
    {
        id: 2164260978,
        label: 'Effet > Esquisse > Craie/Fusain...',
        placement: 'MenuBar',
        name: 'Craie/Fusain...',
    },
    {
        id: 2164260979,
        label: 'Effet > Esquisse > Bas-relief...',
        placement: 'MenuBar',
        name: 'Bas-relief...',
    },
    {
        id: 2164260980,
        label: 'Effet > Contours > Diagonales...',
        placement: 'MenuBar',
        name: 'Diagonales...',
    },
    {
        id: 2164260981,
        label: 'Effet > Contours > Contour accentué...',
        placement: 'MenuBar',
        name: 'Contour accentué...',
    },
    {
        id: 2164260982,
        label: "Effet > Galerie d'effets...",
        placement: 'MenuBar',
        name: "Galerie d'effets...",
    },
    {
        id: 2164260983,
        label: 'Edition > Modifier le dictionnaire personnalisé...',
        placement: 'MenuBar',
        name: 'Modifier le dictionnaire personnalisé...',
    },
    {
        id: 2164260986,
        label: 'Objet > Tracé > Tableau…',
        placement: 'MenuBar',
        name: 'Tableau…',
    },
    {
        id: 2164260988,
        label: 'Texte > Modifier la casse > CAPITALES',
        placement: 'MenuBar',
        name: 'CAPITALES',
    },
    {
        id: 2164260989,
        label: 'Texte > Modifier la casse > minuscules',
        placement: 'MenuBar',
        name: 'minuscules',
    },
    {
        id: 2164260990,
        label: 'Texte > Modifier la casse > Première lettre des mots en majuscules',
        placement: 'MenuBar',
        name: 'Première lettre des mots en majuscules',
    },
    {
        id: 2164260991,
        label: 'Texte > Modifier la casse > Casse de la phrase',
        placement: 'MenuBar',
        name: 'Casse de la phrase',
    },
    {
        id: 2164260992,
        label: 'Texte > Alignement optique des marges',
        placement: 'MenuBar',
        name: 'Alignement optique des marges',
    },
    {
        id: 2164260993,
        label: 'Texte > Trouver/Remplacer la police…',
        placement: 'MenuBar',
        name: 'Trouver/Remplacer la police…',
    },
    {
        id: 2164260994,
        label: 'Texte > Ponctuation typographique...',
        placement: 'MenuBar',
        name: 'Ponctuation typographique...',
    },
    {
        id: 2164260995,
        label: 'Effet > Effets Illustrator',
        placement: 'MenuBar',
        name: 'Effets Illustrator',
    },
    {
        id: 2164260998,
        label: 'Effet > Distorsion et transformation > Transformation...',
        placement: 'MenuBar',
        name: 'Transformation...',
    },
    {
        id: 2164260999,
        label: 'Objet > Transformation > Transformation répartie...',
        placement: 'MenuBar',
        name: 'Transformation répartie...',
    },
    {
        id: 2164261001,
        label: 'Fenêtre > Bibliothèques',
        placement: 'MenuBar',
        name: 'Bibliothèques',
    },
    {
        id: 2164261003,
        label: 'Fenêtre > Trouver des extensions sur Exchange...',
        placement: 'MenuBar',
        name: 'Trouver des extensions sur Exchange...',
    },
    {
        id: 2164261004,
        label: 'Objet > Créer un filet de dégradé...',
        placement: 'MenuBar',
        name: 'Créer un filet de dégradé...',
    },
    {
        id: 2164261005,
        label: 'Fenêtre > Aperçu des séparations',
        placement: 'MenuBar',
        name: 'Aperçu des séparations',
    },
    {
        id: 2164261006,
        label: 'Fenêtre > Liens',
        placement: 'MenuBar',
        name: 'Liens',
    },
    {
        id: 2164261008,
        label: "Edition > Modifier l'original",
        placement: 'MenuBar',
        name: "Modifier l'original",
    },
    {
        id: 2164261010,
        label: 'Fenêtre > Texte > Styles de paragraphe',
        placement: 'MenuBar',
        name: 'Styles de paragraphe',
    },
    {
        id: 2164261011,
        label: 'Fenêtre > Texte > Styles de caractère',
        placement: 'MenuBar',
        name: 'Styles de caractère',
    },
    {
        id: 2164261012,
        label: 'Fenêtre > Plans de travail',
        placement: 'MenuBar',
        name: 'Plans de travail',
    },
    {
        id: 2164261014,
        label: 'Objet > Plans de travail > Réorganiser tous les plans de travail',
        placement: 'MenuBar',
        name: 'Réorganiser tous les plans de travail',
    },
    {
        id: 2164261016,
        label: "Objet > Plans de travail > Ajuster aux limites de l'illustration",
        placement: 'MenuBar',
        name: "Ajuster aux limites de l'illustration",
    },
    {
        id: 2164261017,
        label: "Objet > Plans de travail > Ajuster à l'illustration sélectionnée",
        placement: 'MenuBar',
        name: "Ajuster à l'illustration sélectionnée",
    },
    {
        id: 2164261018,
        label: 'Fenêtre > Propriétés',
        placement: 'MenuBar',
        name: 'Propriétés',
    },
    {
        id: 2164261019,
        label: 'Fenêtre > Navigation',
        placement: 'MenuBar',
        name: 'Navigation',
    },
    {
        id: 2164261022,
        label: 'Fenêtre > Espace de travail > Réinitialiser Getting Started',
        placement: 'MenuBar',
        name: 'Réinitialiser Getting Started',
    },
    {
        id: 2164261023,
        label: 'Fenêtre > Espace de travail > Nouvel espace de travail...',
        placement: 'MenuBar',
        name: 'Nouvel espace de travail...',
    },
    {
        id: 2164261024,
        label: 'Fenêtre > Espace de travail > Gérer les espaces de travail...',
        placement: 'MenuBar',
        name: 'Gérer les espaces de travail...',
    },
    {
        id: 2164261025,
        label: 'Fenêtre > Espace de travail > Getting Started',
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261026,
        label: 'Fenêtre > Espace de travail > Vectorisation',
        placement: 'MenuBar',
        name: 'Vectorisation',
    },
    {
        id: 2164261027,
        label: 'Fenêtre > Espace de travail > Automatisation',
        placement: 'MenuBar',
        name: 'Automatisation',
    },
    {
        id: 2164261028,
        label: 'Fenêtre > Espace de travail > Impression et épreuvage',
        placement: 'MenuBar',
        name: 'Impression et épreuvage',
    },
    {
        id: 2164261029,
        label: 'Fenêtre > Espace de travail > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261030,
        label: 'Fenêtre > Espace de travail > Peinture',
        placement: 'MenuBar',
        name: 'Peinture',
    },
    {
        id: 2164261031,
        label: 'Fenêtre > Espace de travail > Typographie',
        placement: 'MenuBar',
        name: 'Typographie',
    },
    {
        id: 2164261032,
        label: 'Fenêtre > Espace de travail > Les indispensables classiques',
        placement: 'MenuBar',
        name: 'Les indispensables classiques',
    },
    {
        id: 2164261033,
        label: 'Fenêtre > Espace de travail > Mise en forme',
        placement: 'MenuBar',
        name: 'Mise en forme',
    },
    {
        id: 2164261034,
        label: 'Fenêtre > Espace de travail > Les indispensables',
        placement: 'MenuBar',
        name: 'Les indispensables',
    },
    {
        id: 2164261035,
        label: 'Edition > Raccourcis clavier...',
        placement: 'MenuBar',
        name: 'Raccourcis clavier...',
    },
    {
        id: 2164261036,
        label: 'Fenêtre > Styles graphiques',
        placement: 'MenuBar',
        name: 'Styles graphiques',
    },
    {
        id: 2164261037,
        label: 'Fenêtre > Aspect',
        placement: 'MenuBar',
        name: 'Aspect',
    },
    {
        id: 2164261043,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Boutons et transformations',
        placement: 'MenuBar',
        name: 'Boutons et transformations',
    },
    {
        id: 2164261044,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Complément pour forme de goutte',
        placement: 'MenuBar',
        name: 'Complément pour forme de goutte',
    },
    {
        id: 2164261045,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Complément',
        placement: 'MenuBar',
        name: 'Complément',
    },
    {
        id: 2164261046,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Effets 3D',
        placement: 'MenuBar',
        name: 'Effets 3D',
    },
    {
        id: 2164261047,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Effets artistiques',
        placement: 'MenuBar',
        name: 'Effets artistiques',
    },
    {
        id: 2164261048,
        label: "Fenêtre > Bibliothèques de styles graphiques > Effets d'image",
        placement: 'MenuBar',
        name: "Effets d'image",
    },
    {
        id: 2164261049,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Effets de griffonnage',
        placement: 'MenuBar',
        name: 'Effets de griffonnage',
    },
    {
        id: 2164261050,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Effets de néon',
        placement: 'MenuBar',
        name: 'Effets de néon',
    },
    {
        id: 2164261051,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Effets de texte',
        placement: 'MenuBar',
        name: 'Effets de texte',
    },
    {
        id: 2164261052,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Illumination - Styles',
        placement: 'MenuBar',
        name: 'Illumination - Styles',
    },
    {
        id: 2164261053,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Style de motifs Vonster',
        placement: 'MenuBar',
        name: 'Style de motifs Vonster',
    },
    {
        id: 2164261054,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Textures',
        placement: 'MenuBar',
        name: 'Textures',
    },
    {
        id: 2164261057,
        label: 'Fenêtre > Bibliothèques de styles graphiques > Autre bibliothèque...',
        placement: 'MenuBar',
        name: 'Autre bibliothèque...',
    },
    {
        id: 2164261058,
        label: 'Fenêtre > Symboles',
        placement: 'MenuBar',
        name: 'Symboles',
    },
    {
        id: 2164261060,
        label: 'Fenêtre > Bibliothèques de symboles > Boutons et barres Web',
        placement: 'MenuBar',
        name: 'Boutons et barres Web',
    },
    {
        id: 2164261061,
        label: 'Fenêtre > Bibliothèques de symboles > Cheveux et pelage',
        placement: 'MenuBar',
        name: 'Cheveux et pelage',
    },
    {
        id: 2164261062,
        label: 'Fenêtre > Bibliothèques de symboles > Communication',
        placement: 'MenuBar',
        name: 'Communication',
    },
    {
        id: 2164261063,
        label: 'Fenêtre > Bibliothèques de symboles > Ensemble de vecteurs à motif floral',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs à motif floral',
    },
    {
        id: 2164261064,
        label: 'Fenêtre > Bibliothèques de symboles > Ensemble de vecteurs à motif point',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs à motif point',
    },
    {
        id: 2164261065,
        label: 'Fenêtre > Bibliothèques de symboles > Ensemble de vecteurs à motif royal',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs à motif royal',
    },
    {
        id: 2164261066,
        label: 'Fenêtre > Bibliothèques de symboles > Ensemble de vecteurs à motif tâche',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs à motif tâche',
    },
    {
        id: 2164261067,
        label: 'Fenêtre > Bibliothèques de symboles > Ethnique',
        placement: 'MenuBar',
        name: 'Ethnique',
    },
    {
        id: 2164261068,
        label: 'Fenêtre > Bibliothèques de symboles > Festivités',
        placement: 'MenuBar',
        name: 'Festivités',
    },
    {
        id: 2164261069,
        label: 'Fenêtre > Bibliothèques de symboles > Fleurs',
        placement: 'MenuBar',
        name: 'Fleurs',
    },
    {
        id: 2164261070,
        label: 'Fenêtre > Bibliothèques de symboles > Flèches',
        placement: 'MenuBar',
        name: 'Flèches',
    },
    {
        id: 2164261071,
        label: 'Fenêtre > Bibliothèques de symboles > Généalogie',
        placement: 'MenuBar',
        name: 'Généalogie',
    },
    {
        id: 2164261072,
        label: 'Fenêtre > Bibliothèques de symboles > Graphes',
        placement: 'MenuBar',
        name: 'Graphes',
    },
    {
        id: 2164261073,
        label: 'Fenêtre > Bibliothèques de symboles > Icônes Web',
        placement: 'MenuBar',
        name: 'Icônes Web',
    },
    {
        id: 2164261074,
        label: 'Fenêtre > Bibliothèques de symboles > Illumination - Diagrammes de flux',
        placement: 'MenuBar',
        name: 'Illumination - Diagrammes de flux',
    },
    {
        id: 2164261075,
        label: 'Fenêtre > Bibliothèques de symboles > Illumination - Organigrammes',
        placement: 'MenuBar',
        name: 'Illumination - Organigrammes',
    },
    {
        id: 2164261076,
        label: 'Fenêtre > Bibliothèques de symboles > Illumination - Rubans',
        placement: 'MenuBar',
        name: 'Illumination - Rubans',
    },
    {
        id: 2164261077,
        label: 'Fenêtre > Bibliothèques de symboles > Logos',
        placement: 'MenuBar',
        name: 'Logos',
    },
    {
        id: 2164261078,
        label: 'Fenêtre > Bibliothèques de symboles > Mobile',
        placement: 'MenuBar',
        name: 'Mobile',
    },
    {
        id: 2164261079,
        label: 'Fenêtre > Bibliothèques de symboles > Mode',
        placement: 'MenuBar',
        name: 'Mode',
    },
    {
        id: 2164261080,
        label: 'Fenêtre > Bibliothèques de symboles > Nature',
        placement: 'MenuBar',
        name: 'Nature',
    },
    {
        id: 2164261081,
        label: 'Fenêtre > Bibliothèques de symboles > Rétro',
        placement: 'MenuBar',
        name: 'Rétro',
    },
    {
        id: 2164261082,
        label: 'Fenêtre > Bibliothèques de symboles > Sciences',
        placement: 'MenuBar',
        name: 'Sciences',
    },
    {
        id: 2164261083,
        label: 'Fenêtre > Bibliothèques de symboles > Signes',
        placement: 'MenuBar',
        name: 'Signes',
    },
    {
        id: 2164261084,
        label: 'Fenêtre > Bibliothèques de symboles > Sushi',
        placement: 'MenuBar',
        name: 'Sushi',
    },
    {
        id: 2164261085,
        label: 'Fenêtre > Bibliothèques de symboles > Symboles 3D',
        placement: 'MenuBar',
        name: 'Symboles 3D',
    },
    {
        id: 2164261086,
        label: 'Fenêtre > Bibliothèques de symboles > Textures artistiques',
        placement: 'MenuBar',
        name: 'Textures artistiques',
    },
    {
        id: 2164261087,
        label: 'Fenêtre > Bibliothèques de symboles > Tiki',
        placement: 'MenuBar',
        name: 'Tiki',
    },
    {
        id: 2164261090,
        label: 'Fenêtre > Bibliothèques de symboles > Autre bibliothèque...',
        placement: 'MenuBar',
        name: 'Autre bibliothèque...',
    },
    {
        id: 2164261092,
        label: 'Affichage > Repères commentés',
        placement: 'MenuBar',
        name: 'Repères commentés',
    },
    {
        id: 2164261093,
        label: "Fenêtre > Aperçu de l'aplatissement",
        placement: 'MenuBar',
        name: "Aperçu de l'aplatissement",
    },
    {
        id: 2164261094,
        label: 'Fenêtre > Historique',
        placement: 'MenuBar',
        name: 'Historique',
    },
    {
        id: 2164261096,
        label: 'Texte > Glyphes',
        placement: 'MenuBar',
        name: 'Glyphes',
    },
    {
        id: 2164261097,
        label: 'Fenêtre > Texte > Glyphes',
        placement: 'MenuBar',
        name: 'Glyphes',
    },
    {
        id: 2164261098,
        label: "Fenêtre > Scripts d'action",
        placement: 'MenuBar',
        name: "Scripts d'action",
    },
    {
        id: 2164261100,
        label: 'Sélection > Inverser',
        placement: 'MenuBar',
        name: 'Inverser',
    },
    {
        id: 2164261102,
        label: 'Effet > Spécial > Ombre portée...',
        placement: 'MenuBar',
        name: 'Ombre portée...',
    },
    {
        id: 2164261103,
        label: 'Effet > Spécial > Lueur externe...',
        placement: 'MenuBar',
        name: 'Lueur externe...',
    },
    {
        id: 2164261104,
        label: 'Effet > Spécial > Lueur interne...',
        placement: 'MenuBar',
        name: 'Lueur interne...',
    },
    {
        id: 2164261106,
        label: 'Effet > Convertir en > Rectangle...',
        placement: 'MenuBar',
        name: 'Rectangle...',
    },
    {
        id: 2164261107,
        label: 'Effet > Convertir en > Rectangle arrondi...',
        placement: 'MenuBar',
        name: 'Rectangle arrondi...',
    },
    {
        id: 2164261108,
        label: 'Effet > Convertir en > Ellipse...',
        placement: 'MenuBar',
        name: 'Ellipse...',
    },
    {
        id: 2164261109,
        label: 'Effet > Spécial > Arrondis...',
        placement: 'MenuBar',
        name: 'Arrondis...',
    },
    {
        id: 2164261111,
        label: 'Objet > Tracé > Nettoyage...',
        placement: 'MenuBar',
        name: 'Nettoyage...',
    },
    {
        id: 2164261113,
        label: 'Edition > Modifier les couleurs > Surimpression du noir...',
        placement: 'MenuBar',
        name: 'Surimpression du noir...',
    },
    {
        id: 2164261114,
        label: 'Effet > Distorsion et transformation > Distorsion manuelle...',
        placement: 'MenuBar',
        name: 'Distorsion manuelle...',
    },
    {
        id: 2164261115,
        label: 'Effet > Distorsion et transformation > Contraction et dilatation...',
        placement: 'MenuBar',
        name: 'Contraction et dilatation...',
    },
    {
        id: 2164261117,
        label: 'Objet > Habillage de texte > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261118,
        label: 'Objet > Habillage de texte > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261120,
        label: "Objet > Habillage de texte > Options d'habillage de texte…",
        placement: 'MenuBar',
        name: "Options d'habillage de texte…",
    },
    {
        id: 2164261121,
        label: 'Effet > Distorsion et transformation > Peaufinage…',
        placement: 'MenuBar',
        name: 'Peaufinage…',
    },
    {
        id: 2164261122,
        label: "Sélection > Objet > Masques d'écrêtage",
        placement: 'MenuBar',
        name: "Masques d'écrêtage",
    },
    {
        id: 2164261123,
        label: 'Edition > Modifier les couleurs > Dégradé avant -> arrière',
        placement: 'MenuBar',
        name: 'Dégradé avant -> arrière',
    },
    {
        id: 2164261124,
        label: 'Edition > Modifier les couleurs > Dégradé horizontal',
        placement: 'MenuBar',
        name: 'Dégradé horizontal',
    },
    {
        id: 2164261125,
        label: 'Edition > Modifier les couleurs > Dégradé vertical',
        placement: 'MenuBar',
        name: 'Dégradé vertical',
    },
    {
        id: 2164261126,
        label: 'Edition > Modifier les couleurs > Inversion',
        placement: 'MenuBar',
        name: 'Inversion',
    },
    {
        id: 2164261127,
        label: 'Edition > Modifier les couleurs > Conversion en niveaux de gris',
        placement: 'MenuBar',
        name: 'Conversion en niveaux de gris',
    },
    {
        id: 2164261128,
        label: 'Edition > Modifier les couleurs > Conversion en CMJN',
        placement: 'MenuBar',
        name: 'Conversion en CMJN',
    },
    {
        id: 2164261129,
        label: 'Edition > Modifier les couleurs > Conversion en RVB',
        placement: 'MenuBar',
        name: 'Conversion en RVB',
    },
    {
        id: 2164261130,
        label: 'Edition > Modifier les couleurs > Saturation...',
        placement: 'MenuBar',
        name: 'Saturation...',
    },
    {
        id: 2164261132,
        label: "Objet > Tracé > Ajout de point d'ancrage",
        placement: 'MenuBar',
        name: "Ajout de point d'ancrage",
    },
    {
        id: 2164261133,
        label: "Edition > Modifier les couleurs > Correction de l'équilibre des couleurs...",
        placement: 'MenuBar',
        name: "Correction de l'équilibre des couleurs...",
    },
    {
        id: 2164261134,
        label: 'Objet > Créer une mosaïque...',
        placement: 'MenuBar',
        name: 'Créer une mosaïque...',
    },
    {
        id: 2164261135,
        label: 'Effet > Distorsion et transformation > Esquisse...',
        placement: 'MenuBar',
        name: 'Esquisse...',
    },
    {
        id: 2164261136,
        label: 'Sélection > Resélectionner',
        placement: 'MenuBar',
        name: 'Resélectionner',
    },
    {
        id: 2164261138,
        label: 'Sélection > Identique > Formes et texte',
        placement: 'MenuBar',
        name: 'Formes et texte',
    },
    {
        id: 2164261139,
        label: 'Sélection > Identique > Texte',
        placement: 'MenuBar',
        name: 'Texte',
    },
    {
        id: 2164261141,
        label: 'Sélection > Identique > Couleur de fond',
        placement: 'MenuBar',
        name: 'Couleur de fond',
    },
    {
        id: 2164261142,
        label: 'Sélection > Identique > Style graphique',
        placement: 'MenuBar',
        name: 'Style graphique',
    },
    {
        id: 2164261143,
        label: 'Sélection > Identique > Contour et fond',
        placement: 'MenuBar',
        name: 'Contour et fond',
    },
    {
        id: 2164261144,
        label: 'Sélection > Identique > Couleur de contour',
        placement: 'MenuBar',
        name: 'Couleur de contour',
    },
    {
        id: 2164261145,
        label: 'Sélection > Identique > Epaisseur de contour',
        placement: 'MenuBar',
        name: 'Epaisseur de contour',
    },
    {
        id: 2164261146,
        label: 'Sélection > Identique > Mode de fusion',
        placement: 'MenuBar',
        name: 'Mode de fusion',
    },
    {
        id: 2164261147,
        label: 'Sélection > Identique > Opacité',
        placement: 'MenuBar',
        name: 'Opacité',
    },
    {
        id: 2164261148,
        label: 'Sélection > Identique > Forme',
        placement: 'MenuBar',
        name: 'Forme',
    },
    {
        id: 2164261149,
        label: 'Sélection > Identique > Instance de symbole',
        placement: 'MenuBar',
        name: 'Instance de symbole',
    },
    {
        id: 2164261150,
        label: 'Sélection > Identique > Série de blocs liés',
        placement: 'MenuBar',
        name: 'Série de blocs liés',
    },
    {
        id: 2164261151,
        label: 'Sélection > Identique > Aspect',
        placement: 'MenuBar',
        name: 'Aspect',
    },
    {
        id: 2164261152,
        label: "Sélection > Identique > Attribut d'aspect",
        placement: 'MenuBar',
        name: "Attribut d'aspect",
    },
    {
        id: 2164261153,
        label: 'Sélection > Identique > Couleur de fond du texte',
        placement: 'MenuBar',
        name: 'Couleur de fond du texte',
    },
    {
        id: 2164261154,
        label: 'Sélection > Identique > Couleur de contour du texte',
        placement: 'MenuBar',
        name: 'Couleur de contour du texte',
    },
    {
        id: 2164261155,
        label: 'Sélection > Identique > Couleur de fond et de contour du texte',
        placement: 'MenuBar',
        name: 'Couleur de fond et de contour du texte',
    },
    {
        id: 2164261156,
        label: 'Sélection > Identique > Corps de police',
        placement: 'MenuBar',
        name: 'Corps de police',
    },
    {
        id: 2164261157,
        label: 'Sélection > Identique > Famille de polices',
        placement: 'MenuBar',
        name: 'Famille de polices',
    },
    {
        id: 2164261158,
        label: 'Sélection > Identique > Famille et style de police',
        placement: 'MenuBar',
        name: 'Famille et style de police',
    },
    {
        id: 2164261159,
        label: 'Sélection > Identique > Famille, style et taille de police',
        placement: 'MenuBar',
        name: 'Famille, style et taille de police',
    },
    {
        id: 2164261160,
        label: 'Sélection > Objet > Points isolés',
        placement: 'MenuBar',
        name: 'Points isolés',
    },
    {
        id: 2164261162,
        label: 'Sélection > Objet > Tous les objets texte',
        placement: 'MenuBar',
        name: 'Tous les objets texte',
    },
    {
        id: 2164261163,
        label: 'Sélection > Objet > Objets texte de point',
        placement: 'MenuBar',
        name: 'Objets texte de point',
    },
    {
        id: 2164261164,
        label: 'Sélection > Objet > Objets texte captif',
        placement: 'MenuBar',
        name: 'Objets texte captif',
    },
    {
        id: 2164261165,
        label: 'Effet > Distorsion et transformation > Zigzag...',
        placement: 'MenuBar',
        name: 'Zigzag...',
    },
    {
        id: 2164261166,
        label: 'Effet > Traits de coupe',
        placement: 'MenuBar',
        name: 'Traits de coupe',
    },
    {
        id: 2164261167,
        label: 'Objet > Créer des traits de coupe',
        placement: 'MenuBar',
        name: 'Créer des traits de coupe',
    },
    {
        id: 2164261168,
        label: 'Fichier > Assemblage...',
        placement: 'MenuBar',
        name: 'Assemblage...',
    },
    {
        id: 2164261169,
        label: 'Fenêtre > Calques',
        placement: 'MenuBar',
        name: 'Calques',
    },
    {
        id: 2164261172,
        label: 'Fichier > Parcourir dans Bridge...',
        placement: 'MenuBar',
        name: 'Parcourir dans Bridge...',
    },
    {
        id: 2164261173,
        label: 'Fichier > Informations...',
        placement: 'MenuBar',
        name: 'Informations...',
    },
    {
        id: 2164261174,
        label: 'Fenêtre > Informations sur le document',
        placement: 'MenuBar',
        name: 'Informations sur le document',
    },
    {
        id: 2164261176,
        label: 'Effet > Pathfinder > Réunion',
        placement: 'MenuBar',
        name: 'Réunion',
    },
    {
        id: 2164261177,
        label: 'Effet > Pathfinder > Intersection',
        placement: 'MenuBar',
        name: 'Intersection',
    },
    {
        id: 2164261178,
        label: 'Effet > Pathfinder > Exclusion',
        placement: 'MenuBar',
        name: 'Exclusion',
    },
    {
        id: 2164261179,
        label: 'Effet > Pathfinder > Soustraction',
        placement: 'MenuBar',
        name: 'Soustraction',
    },
    {
        id: 2164261180,
        label: 'Effet > Pathfinder > Soustraction (avant - arrière)',
        placement: 'MenuBar',
        name: 'Soustraction (avant - arrière)',
    },
    {
        id: 2164261181,
        label: 'Effet > Pathfinder > Division',
        placement: 'MenuBar',
        name: 'Division',
    },
    {
        id: 2164261182,
        label: 'Effet > Pathfinder > Pochoir',
        placement: 'MenuBar',
        name: 'Pochoir',
    },
    {
        id: 2164261183,
        label: 'Effet > Pathfinder > Fusion',
        placement: 'MenuBar',
        name: 'Fusion',
    },
    {
        id: 2164261184,
        label: 'Effet > Pathfinder > Découpe',
        placement: 'MenuBar',
        name: 'Découpe',
    },
    {
        id: 2164261185,
        label: 'Effet > Pathfinder > Contour',
        placement: 'MenuBar',
        name: 'Contour',
    },
    {
        id: 2164261186,
        label: 'Effet > Pathfinder > Mélange maximal',
        placement: 'MenuBar',
        name: 'Mélange maximal',
    },
    {
        id: 2164261187,
        label: 'Effet > Pathfinder > Mélange pondéré...',
        placement: 'MenuBar',
        name: 'Mélange pondéré...',
    },
    {
        id: 2164261188,
        label: 'Effet > Pathfinder > Recouvrement...',
        placement: 'MenuBar',
        name: 'Recouvrement...',
    },
    {
        id: 2164261189,
        label: 'Affichage > Afficher les espaces de peinture dynamique',
        placement: 'MenuBar',
        name: 'Afficher les espaces de peinture dynamique',
    },
    {
        id: 2164261192,
        label: 'Objet > Peinture dynamique > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261193,
        label: 'Objet > Peinture dynamique > Fusionner',
        placement: 'MenuBar',
        name: 'Fusionner',
    },
    {
        id: 2164261194,
        label: 'Objet > Peinture dynamique > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261196,
        label: "Objet > Peinture dynamique > Options d'espace...",
        placement: 'MenuBar',
        name: "Options d'espace...",
    },
    {
        id: 2164261198,
        label: 'Objet > Peinture dynamique > Décomposer',
        placement: 'MenuBar',
        name: 'Décomposer',
    },
    {
        id: 2164261199,
        label: 'Effet > Spécial > Griffonnage…',
        placement: 'MenuBar',
        name: 'Griffonnage…',
    },
    {
        id: 2164261201,
        label: "Objet > Distorsion de l'enveloppe > Créer d'après une déformation...",
        placement: 'MenuBar',
        name: "Créer d'après une déformation...",
    },
    {
        id: 2164261202,
        label: "Objet > Distorsion de l'enveloppe > Créer d'après un filet...",
        placement: 'MenuBar',
        name: "Créer d'après un filet...",
    },
    {
        id: 2164261203,
        label: "Objet > Distorsion de l'enveloppe > Créer d'après l'objet au premier plan",
        placement: 'MenuBar',
        name: "Créer d'après l'objet au premier plan",
    },
    {
        id: 2164261204,
        label: "Objet > Distorsion de l'enveloppe > Annuler",
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261206,
        label: "Objet > Distorsion de l'enveloppe > Options de l'enveloppe...",
        placement: 'MenuBar',
        name: "Options de l'enveloppe...",
    },
    {
        id: 2164261208,
        label: "Objet > Distorsion de l'enveloppe > Décomposer",
        placement: 'MenuBar',
        name: 'Décomposer',
    },
    {
        id: 2164261210,
        label: "Objet > Distorsion de l'enveloppe > Modifier le contenu",
        placement: 'MenuBar',
        name: 'Modifier le contenu',
    },
    {
        id: 2164261212,
        label: 'Effet > Déformation > Arc...',
        placement: 'MenuBar',
        name: 'Arc...',
    },
    {
        id: 2164261213,
        label: 'Effet > Déformation > Arc inférieur...',
        placement: 'MenuBar',
        name: 'Arc inférieur...',
    },
    {
        id: 2164261214,
        label: 'Effet > Déformation > Arc supérieur...',
        placement: 'MenuBar',
        name: 'Arc supérieur...',
    },
    {
        id: 2164261215,
        label: 'Effet > Déformation > Arche...',
        placement: 'MenuBar',
        name: 'Arche...',
    },
    {
        id: 2164261216,
        label: 'Effet > Déformation > Renflement...',
        placement: 'MenuBar',
        name: 'Renflement...',
    },
    {
        id: 2164261217,
        label: 'Effet > Déformation > Coquille vers le bas...',
        placement: 'MenuBar',
        name: 'Coquille vers le bas...',
    },
    {
        id: 2164261218,
        label: 'Effet > Déformation > Coquille vers le haut...',
        placement: 'MenuBar',
        name: 'Coquille vers le haut...',
    },
    {
        id: 2164261219,
        label: 'Effet > Déformation > Drapeau...',
        placement: 'MenuBar',
        name: 'Drapeau...',
    },
    {
        id: 2164261220,
        label: 'Effet > Déformation > Onde...',
        placement: 'MenuBar',
        name: 'Onde...',
    },
    {
        id: 2164261221,
        label: 'Effet > Déformation > Poisson...',
        placement: 'MenuBar',
        name: 'Poisson...',
    },
    {
        id: 2164261222,
        label: 'Effet > Déformation > Montée...',
        placement: 'MenuBar',
        name: 'Montée...',
    },
    {
        id: 2164261223,
        label: 'Effet > Déformation > Objectif 180°...',
        placement: 'MenuBar',
        name: 'Objectif 180°...',
    },
    {
        id: 2164261224,
        label: 'Effet > Déformation > Dilatation...',
        placement: 'MenuBar',
        name: 'Dilatation...',
    },
    {
        id: 2164261225,
        label: 'Effet > Déformation > Compression...',
        placement: 'MenuBar',
        name: 'Compression...',
    },
    {
        id: 2164261226,
        label: 'Effet > Déformation > Torsion...',
        placement: 'MenuBar',
        name: 'Torsion...',
    },
    {
        id: 2164261227,
        label: 'Objet > Décomposer...',
        placement: 'MenuBar',
        name: 'Décomposer...',
    },
    {
        id: 2164261229,
        label: 'Edition > Orthographe > Vérification orthographique automatique',
        placement: 'MenuBar',
        name: 'Vérification orthographique automatique',
    },
    {
        id: 2164261230,
        label: 'Edition > Orthographe > Orthographe...',
        placement: 'MenuBar',
        name: 'Orthographe...',
    },
    {
        id: 2164261231,
        label: 'Sélection > Démarrer la modification globale',
        placement: 'MenuBar',
        name: 'Démarrer la modification globale',
    },
    {
        id: 2164261232,
        label: 'Illustrator > Préférences > Performances...',
        placement: 'MenuBar',
        name: 'Performances...',
    },
    {
        id: 2164261233,
        label: 'Illustrator > Préférences > Gestion des fichiers...',
        placement: 'MenuBar',
        name: 'Gestion des fichiers...',
    },
    {
        id: 2164261234,
        label: 'Illustrator > Préférences > Gestion du presse-papiers...',
        placement: 'MenuBar',
        name: 'Gestion du presse-papiers...',
    },
    {
        id: 2164261235,
        label: 'Illustrator > Préférences > Aspect du noir...',
        placement: 'MenuBar',
        name: 'Aspect du noir...',
    },
    {
        id: 2164261236,
        label: 'Illustrator > Préférences > Appareils...',
        placement: 'MenuBar',
        name: 'Appareils...',
    },
    {
        id: 2164261237,
        label: 'Fenêtre > Formes',
        placement: 'MenuBar',
        name: 'Formes',
    },
    {
        id: 2164261238,
        label: 'Sélection > Objet > Contours',
        placement: 'MenuBar',
        name: 'Contours',
    },
    {
        id: 2164261241,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_Aquarelle',
        placement: 'MenuBar',
        name: 'Artistiques_Aquarelle',
    },
    {
        id: 2164261242,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_Calligraphiques',
        placement: 'MenuBar',
        name: 'Artistiques_Calligraphiques',
    },
    {
        id: 2164261243,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_CraieFusainCrayon',
        placement: 'MenuBar',
        name: 'Artistiques_CraieFusainCrayon',
    },
    {
        id: 2164261244,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_Effilage',
        placement: 'MenuBar',
        name: 'Artistiques_Effilage',
    },
    {
        id: 2164261245,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_Encre',
        placement: 'MenuBar',
        name: 'Artistiques_Encre',
    },
    {
        id: 2164261246,
        label: 'Fenêtre > Bibliothèques de formes > Artistiques > Artistiques_Pinceau',
        placement: 'MenuBar',
        name: 'Artistiques_Pinceau',
    },
    {
        id: 2164261248,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Cadres',
        placement: 'MenuBar',
        name: 'Bordures_Cadres',
    },
    {
        id: 2164261249,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Décoratif',
        placement: 'MenuBar',
        name: 'Bordures_Décoratif',
    },
    {
        id: 2164261250,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Ethnique',
        placement: 'MenuBar',
        name: 'Bordures_Ethnique',
    },
    {
        id: 2164261251,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Fantaisie',
        placement: 'MenuBar',
        name: 'Bordures_Fantaisie',
    },
    {
        id: 2164261252,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Géométrique',
        placement: 'MenuBar',
        name: 'Bordures_Géométrique',
    },
    {
        id: 2164261253,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Pointillé',
        placement: 'MenuBar',
        name: 'Bordures_Pointillé',
    },
    {
        id: 2164261254,
        label: 'Fenêtre > Bibliothèques de formes > Bordures > Bordures_Traits',
        placement: 'MenuBar',
        name: 'Bordures_Traits',
    },
    {
        id: 2164261256,
        label: 'Fenêtre > Bibliothèques de formes > Décoratif > Décoratif_BannièresSceaux',
        placement: 'MenuBar',
        name: 'Décoratif_BannièresSceaux',
    },
    {
        id: 2164261257,
        label: 'Fenêtre > Bibliothèques de formes > Décoratif > Décoratif_Diffusion',
        placement: 'MenuBar',
        name: 'Décoratif_Diffusion',
    },
    {
        id: 2164261258,
        label: 'Fenêtre > Bibliothèques de formes > Décoratif > Décoratif_SéparateursTexte',
        placement: 'MenuBar',
        name: 'Décoratif_SéparateursTexte',
    },
    {
        id: 2164261259,
        label: 'Fenêtre > Bibliothèques de formes > Décoratif > Ensemble de courbes élégantes et de formes florales',
        placement: 'MenuBar',
        name: 'Ensemble de courbes élégantes et de formes florales',
    },
    {
        id: 2164261261,
        label: 'Fenêtre > Bibliothèques de formes > Ensembles de vecteurs > Ensemble de vecteurs de formes de traces',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs de formes de traces',
    },
    {
        id: 2164261262,
        label: 'Fenêtre > Bibliothèques de formes > Ensembles de vecteurs > Ensemble de vecteurs de formes tracées à la main',
        placement: 'MenuBar',
        name: 'Ensemble de vecteurs de formes tracées à la main',
    },
    {
        id: 2164261264,
        label: 'Fenêtre > Bibliothèques de formes > Flèches > Flèches de motif',
        placement: 'MenuBar',
        name: 'Flèches de motif',
    },
    {
        id: 2164261265,
        label: 'Fenêtre > Bibliothèques de formes > Flèches > Flèches_Spécial',
        placement: 'MenuBar',
        name: 'Flèches_Spécial',
    },
    {
        id: 2164261266,
        label: 'Fenêtre > Bibliothèques de formes > Flèches > Flèches_Standard',
        placement: 'MenuBar',
        name: 'Flèches_Standard',
    },
    {
        id: 2164261268,
        label: "Fenêtre > Bibliothèques de formes > Forme d'image > Bibliothèque de formes d'image",
        placement: 'MenuBar',
        name: "Bibliothèque de formes d'image",
    },
    {
        id: 2164261270,
        label: 'Fenêtre > Bibliothèques de formes > Formes Wacom 6D > Formes de stylo artistique 6d',
        placement: 'MenuBar',
        name: 'Formes de stylo artistique 6d',
    },
    {
        id: 2164261272,
        label: 'Fenêtre > Bibliothèques de formes > Pointe du pinceau > Bibliothèque de pointes de pinceau',
        placement: 'MenuBar',
        name: 'Bibliothèque de pointes de pinceau',
    },
    {
        id: 2164261275,
        label: 'Fenêtre > Bibliothèques de formes > Autre bibliothèque...',
        placement: 'MenuBar',
        name: 'Autre bibliothèque...',
    },
    {
        id: 2164261276,
        label: 'Fenêtre > Pathfinder',
        placement: 'MenuBar',
        name: 'Pathfinder',
    },
    {
        id: 2164261277,
        label: 'Edition > Rechercher et remplacer...',
        placement: 'MenuBar',
        name: 'Rechercher et remplacer...',
    },
    {
        id: 2164261278,
        label: 'Edition > Suivant',
        placement: 'MenuBar',
        name: 'Suivant',
    },
    {
        id: 2164261279,
        label: 'Effet > Pixellisation...',
        placement: 'MenuBar',
        name: 'Pixellisation...',
    },
    {
        id: 2164261281,
        label: 'Effet > Paramètres des effets de pixellisation du document...',
        placement: 'MenuBar',
        name: 'Paramètres des effets de pixellisation du document...',
    },
    {
        id: 2164261282,
        label: 'Objet > Pixelliser...',
        placement: 'MenuBar',
        name: 'Pixelliser...',
    },
    {
        id: 2164261284,
        label: 'Objet > Dégradé de formes > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261285,
        label: 'Objet > Dégradé de formes > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261287,
        label: 'Objet > Dégradé de formes > Options de dégradés...',
        placement: 'MenuBar',
        name: 'Options de dégradés...',
    },
    {
        id: 2164261289,
        label: 'Objet > Dégradé de formes > Décomposer',
        placement: 'MenuBar',
        name: 'Décomposer',
    },
    {
        id: 2164261291,
        label: 'Objet > Dégradé de formes > Remplacer le chemin',
        placement: 'MenuBar',
        name: 'Remplacer le chemin',
    },
    {
        id: 2164261292,
        label: 'Objet > Dégradé de formes > Inverser le chemin',
        placement: 'MenuBar',
        name: 'Inverser le chemin',
    },
    {
        id: 2164261293,
        label: 'Objet > Dégradé de formes > Inversion avant - arrière',
        placement: 'MenuBar',
        name: 'Inversion avant - arrière',
    },
    {
        id: 2164261295,
        label: 'Affichage > Afficher les tranches',
        placement: 'MenuBar',
        name: 'Afficher les tranches',
    },
    {
        id: 2164261296,
        label: 'Affichage > Verrouiller les tranches',
        placement: 'MenuBar',
        name: 'Verrouiller les tranches',
    },
    {
        id: 2164261299,
        label: 'Objet > Tranche > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261300,
        label: 'Objet > Tranche > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261302,
        label: "Objet > Tranche > Créer d'après les repères",
        placement: 'MenuBar',
        name: "Créer d'après les repères",
    },
    {
        id: 2164261303,
        label: "Objet > Tranche > Créer d'après la sélection",
        placement: 'MenuBar',
        name: "Créer d'après la sélection",
    },
    {
        id: 2164261305,
        label: 'Objet > Tranche > Dupliquer la tranche',
        placement: 'MenuBar',
        name: 'Dupliquer la tranche',
    },
    {
        id: 2164261306,
        label: 'Objet > Tranche > Combiner les tranches',
        placement: 'MenuBar',
        name: 'Combiner les tranches',
    },
    {
        id: 2164261307,
        label: 'Objet > Tranche > Diviser les tranches...',
        placement: 'MenuBar',
        name: 'Diviser les tranches...',
    },
    {
        id: 2164261308,
        label: 'Objet > Tranche > Tout supprimer',
        placement: 'MenuBar',
        name: 'Tout supprimer',
    },
    {
        id: 2164261310,
        label: 'Objet > Tranche > Options de tranche...',
        placement: 'MenuBar',
        name: 'Options de tranche...',
    },
    {
        id: 2164261312,
        label: 'Objet > Tranche > Ecrêter selon le plan de travail',
        placement: 'MenuBar',
        name: 'Ecrêter selon le plan de travail',
    },
    {
        id: 2164261313,
        label: 'Fenêtre > Retype',
        placement: 'MenuBar',
        name: 'Retype',
    },
    {
        id: 2164261314,
        label: 'Fichier > Enregistrer les tranches sélectionnées...',
        placement: 'MenuBar',
        name: 'Enregistrer les tranches sélectionnées...',
    },
    {
        id: 2164261316,
        label: 'Effet > Filtres SVG > Appliquer le filtre SVG...',
        placement: 'MenuBar',
        name: 'Appliquer le filtre SVG...',
    },
    {
        id: 2164261317,
        label: 'Effet > Filtres SVG > Importer le filtre SVG...',
        placement: 'MenuBar',
        name: 'Importer le filtre SVG...',
    },
    {
        id: 2164261319,
        label: 'Effet > Spécial > Contour progressif...',
        placement: 'MenuBar',
        name: 'Contour progressif...',
    },
    {
        id: 2164261321,
        label: 'Effet > 3D et matières > Extrusion et biseau...',
        placement: 'MenuBar',
        name: 'Extrusion et biseau...',
    },
    {
        id: 2164261322,
        label: 'Effet > 3D et matières > Révolution...',
        placement: 'MenuBar',
        name: 'Révolution...',
    },
    {
        id: 2164261323,
        label: 'Effet > 3D et matières > Dilatation...',
        placement: 'MenuBar',
        name: 'Dilatation...',
    },
    {
        id: 2164261324,
        label: 'Effet > 3D et matières > Rotation...',
        placement: 'MenuBar',
        name: 'Rotation...',
    },
    {
        id: 2164261325,
        label: 'Effet > 3D et matières > Matières...',
        placement: 'MenuBar',
        name: 'Matières...',
    },
    {
        id: 2164261327,
        label: 'Effet > 3D et matières > 3D (Classique) > Extrusion et biseautage (classique)...',
        placement: 'MenuBar',
        name: 'Extrusion et biseautage (classique)...',
    },
    {
        id: 2164261328,
        label: 'Effet > 3D et matières > 3D (Classique) > Révolution (classique)...',
        placement: 'MenuBar',
        name: 'Révolution (classique)...',
    },
    {
        id: 2164261329,
        label: 'Effet > 3D et matières > 3D (Classique) > Rotation (classique)...',
        placement: 'MenuBar',
        name: 'Rotation (classique)...',
    },
    {
        id: 2164261330,
        label: 'Fenêtre > Interactivité SVG',
        placement: 'MenuBar',
        name: 'Interactivité SVG',
    },
    {
        id: 2164261331,
        label: "Objet > Recadrer l'image",
        placement: 'MenuBar',
        name: "Recadrer l'image",
    },
    {
        id: 2164261332,
        label: 'Fenêtre > Variables',
        placement: 'MenuBar',
        name: 'Variables',
    },
    {
        id: 2164261334,
        label: 'Fenêtre > Baguette magique',
        placement: 'MenuBar',
        name: 'Baguette magique',
    },
    {
        id: 2164261335,
        label: 'Objet > Tracé > Diviser les objets inférieurs',
        placement: 'MenuBar',
        name: 'Diviser les objets inférieurs',
    },
    {
        id: 2164261336,
        label: 'Sélection > Objet > Contours de la pointe du pinceau',
        placement: 'MenuBar',
        name: 'Contours de la pointe du pinceau',
    },
    {
        id: 2164261338,
        label: 'Objet > Transformation > Réinitialiser le cadre de sélection',
        placement: 'MenuBar',
        name: 'Réinitialiser le cadre de sélection',
    },
    {
        id: 2164261339,
        label: 'Affichage > Masquer le cadre de sélection',
        placement: 'MenuBar',
        name: 'Masquer le cadre de sélection',
    },
    {
        id: 2164261340,
        label: 'Objet > Disposition > Envoyer vers le calque sélectionné',
        placement: 'MenuBar',
        name: 'Envoyer vers le calque sélectionné',
    },
    {
        id: 2164261342,
        label: 'Objet > Verrouiller > Tous les objets supérieurs',
        placement: 'MenuBar',
        name: 'Tous les objets supérieurs',
    },
    {
        id: 2164261343,
        label: 'Objet > Verrouiller > Autres calques',
        placement: 'MenuBar',
        name: 'Autres calques',
    },
    {
        id: 2164261344,
        label: 'Objet > Masquer > Tous les objets supérieurs',
        placement: 'MenuBar',
        name: 'Tous les objets supérieurs',
    },
    {
        id: 2164261345,
        label: 'Objet > Masquer > Autres calques',
        placement: 'MenuBar',
        name: 'Autres calques',
    },
    {
        id: 2164261346,
        label: 'Sélection > Objet > Tout sur les mêmes calques',
        placement: 'MenuBar',
        name: 'Tout sur les mêmes calques',
    },
    {
        id: 2164261347,
        label: 'Sélection > Objet > Poignées directrices',
        placement: 'MenuBar',
        name: 'Poignées directrices',
    },
    {
        id: 2164261350,
        label: 'Sélection > Objet précédent',
        placement: 'MenuBar',
        name: 'Objet précédent',
    },
    {
        id: 2164261351,
        label: 'Sélection > Objet suivant',
        placement: 'MenuBar',
        name: 'Objet suivant',
    },
    {
        id: 2164261354,
        label: 'Sélection > Mémoriser la sélection...',
        placement: 'MenuBar',
        name: 'Mémoriser la sélection...',
    },
    {
        id: 2164261355,
        label: 'Sélection > Modifier la sélection...',
        placement: 'MenuBar',
        name: 'Modifier la sélection...',
    },
    {
        id: 2164261356,
        label: 'Sélection > Mettre à jour la sélection',
        placement: 'MenuBar',
        name: 'Mettre à jour la sélection',
    },
    {
        id: 2164261357,
        label: 'Objet > Tracé > Simplifier...',
        placement: 'MenuBar',
        name: 'Simplifier...',
    },
    {
        id: 2164261358,
        label: 'Objet > Tracé > Lisser…',
        placement: 'MenuBar',
        name: 'Lisser…',
    },
    {
        id: 2164261360,
        label: 'Objet > Maquette > Prévisualiser la maquette',
        placement: 'MenuBar',
        name: 'Prévisualiser la maquette',
    },
    {
        id: 2164261361,
        label: 'Objet > Maquette > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261362,
        label: 'Objet > Maquette > Modifier',
        placement: 'MenuBar',
        name: 'Modifier',
    },
    {
        id: 2164261363,
        label: 'Effet > Distorsion et transformation > Torsion...',
        placement: 'MenuBar',
        name: 'Torsion...',
    },
    {
        id: 2164261367,
        label: 'Fichier > Scripts > Autre script...',
        placement: 'MenuBar',
        name: 'Autre script...',
    },
    {
        id: 2164261368,
        label: 'Fenêtre > Propriétés CSS (obsolète)',
        placement: 'MenuBar',
        name: 'Propriétés CSS (obsolète)',
    },
    {
        id: 2164261370,
        label: 'Effet > Tracé > Vectoriser l’objet',
        placement: 'MenuBar',
        name: 'Vectoriser l’objet',
    },
    {
        id: 2164261371,
        label: 'Fenêtre > Couleur',
        placement: 'MenuBar',
        name: 'Couleur',
    },
    {
        id: 2164261373,
        label: 'Fenêtre > Dégradé de couleurs',
        placement: 'MenuBar',
        name: 'Dégradé de couleurs',
    },
    {
        id: 2164261374,
        label: 'Fenêtre > Contour',
        placement: 'MenuBar',
        name: 'Contour',
    },
    {
        id: 2164261375,
        label: "Affichage > Masquer l'annotateur de dégradé de couleurs",
        placement: 'MenuBar',
        name: "Masquer l'annotateur de dégradé de couleurs",
    },
    {
        id: 2164261376,
        label: 'Objet > Tracé > Inverser la direction des tracés',
        placement: 'MenuBar',
        name: 'Inverser la direction des tracés',
    },
    {
        id: 2164261377,
        label: 'Fenêtre > Transparence',
        placement: 'MenuBar',
        name: 'Transparence',
    },
    {
        id: 2164261378,
        label: 'Affichage > Afficher le damier de transparence',
        placement: 'MenuBar',
        name: 'Afficher le damier de transparence',
    },
    {
        id: 2164261379,
        label: 'Fenêtre > Nuancier',
        placement: 'MenuBar',
        name: 'Nuancier',
    },
    {
        id: 2164261382,
        label: 'Fenêtre > Options de motif',
        placement: 'MenuBar',
        name: 'Options de motif',
    },
    {
        id: 2164261383,
        label: 'Fenêtre > Générer des motifs (Beta)',
        placement: 'MenuBar',
        name: 'Générer des motifs (Beta)',
    },
    {
        id: 2164261385,
        label: 'Objet > Motif > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261387,
        label: 'Objet > Motif > Modifier le motif',
        placement: 'MenuBar',
        name: 'Modifier le motif',
    },
    {
        id: 2164261388,
        label: 'Objet > Motif > Couleur du bord de la mosaïque...',
        placement: 'MenuBar',
        name: 'Couleur du bord de la mosaïque...',
    },
    {
        id: 2164261390,
        label: 'Objet > Motif > Générer des motifs (Beta)',
        placement: 'MenuBar',
        name: 'Générer des motifs (Beta)',
    },
    {
        id: 2164261392,
        label: 'Fenêtre > Bibliothèques de nuances > Aliments > Boissons',
        placement: 'MenuBar',
        name: 'Boissons',
    },
    {
        id: 2164261393,
        label: 'Fenêtre > Bibliothèques de nuances > Aliments > Crème glacée',
        placement: 'MenuBar',
        name: 'Crème glacée',
    },
    {
        id: 2164261394,
        label: 'Fenêtre > Bibliothèques de nuances > Aliments > Friandises',
        placement: 'MenuBar',
        name: 'Friandises',
    },
    {
        id: 2164261395,
        label: 'Fenêtre > Bibliothèques de nuances > Aliments > Fruits',
        placement: 'MenuBar',
        name: 'Fruits',
    },
    {
        id: 2164261396,
        label: 'Fenêtre > Bibliothèques de nuances > Aliments > Légumes',
        placement: 'MenuBar',
        name: 'Légumes',
    },
    {
        id: 2164261397,
        label: 'Fenêtre > Bibliothèques de nuances > Articles pour enfants',
        placement: 'MenuBar',
        name: 'Articles pour enfants',
    },
    {
        id: 2164261399,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > Couleurs ANPA',
        placement: 'MenuBar',
        name: 'Couleurs ANPA',
    },
    {
        id: 2164261400,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > DIC Color Guide',
        placement: 'MenuBar',
        name: 'DIC Color Guide',
    },
    {
        id: 2164261401,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > FOCOLTONE',
        placement: 'MenuBar',
        name: 'FOCOLTONE',
    },
    {
        id: 2164261402,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS E Process',
        placement: 'MenuBar',
        name: 'HKS E Process',
    },
    {
        id: 2164261403,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS E',
        placement: 'MenuBar',
        name: 'HKS E',
    },
    {
        id: 2164261404,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS K Process',
        placement: 'MenuBar',
        name: 'HKS K Process',
    },
    {
        id: 2164261405,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS K',
        placement: 'MenuBar',
        name: 'HKS K',
    },
    {
        id: 2164261406,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS N Process',
        placement: 'MenuBar',
        name: 'HKS N Process',
    },
    {
        id: 2164261407,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS N',
        placement: 'MenuBar',
        name: 'HKS N',
    },
    {
        id: 2164261408,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS Z Process',
        placement: 'MenuBar',
        name: 'HKS Z Process',
    },
    {
        id: 2164261409,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > HKS Z',
        placement: 'MenuBar',
        name: 'HKS Z',
    },
    {
        id: 2164261410,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > TOYO 94 COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO 94 COLOR FINDER',
    },
    {
        id: 2164261411,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > TOYO COLOR FINDER',
        placement: 'MenuBar',
        name: 'TOYO COLOR FINDER',
    },
    {
        id: 2164261412,
        label: 'Fenêtre > Bibliothèques de nuances > Catalogues de couleurs > TRUMATCH',
        placement: 'MenuBar',
        name: 'TRUMATCH',
    },
    {
        id: 2164261414,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Bois',
        placement: 'MenuBar',
        name: 'Bois',
    },
    {
        id: 2164261415,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Ciel',
        placement: 'MenuBar',
        name: 'Ciel',
    },
    {
        id: 2164261416,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Combinaisons de couleurs',
        placement: 'MenuBar',
        name: 'Combinaisons de couleurs',
    },
    {
        id: 2164261417,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Couleurs vives',
        placement: 'MenuBar',
        name: 'Couleurs vives',
    },
    {
        id: 2164261418,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Eau',
        placement: 'MenuBar',
        name: 'Eau',
    },
    {
        id: 2164261419,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Feuillage',
        placement: 'MenuBar',
        name: 'Feuillage',
    },
    {
        id: 2164261420,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Fondus',
        placement: 'MenuBar',
        name: 'Fondus',
    },
    {
        id: 2164261421,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Fruits et légumes',
        placement: 'MenuBar',
        name: 'Fruits et légumes',
    },
    {
        id: 2164261422,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Harmonies couleur',
        placement: 'MenuBar',
        name: 'Harmonies couleur',
    },
    {
        id: 2164261423,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Métaux',
        placement: 'MenuBar',
        name: 'Métaux',
    },
    {
        id: 2164261424,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Minérales',
        placement: 'MenuBar',
        name: 'Minérales',
    },
    {
        id: 2164261425,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Neutres',
        placement: 'MenuBar',
        name: 'Neutres',
    },
    {
        id: 2164261426,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Pastels',
        placement: 'MenuBar',
        name: 'Pastels',
    },
    {
        id: 2164261427,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Pierre et brique',
        placement: 'MenuBar',
        name: 'Pierre et brique',
    },
    {
        id: 2164261428,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Pierres et bijoux',
        placement: 'MenuBar',
        name: 'Pierres et bijoux',
    },
    {
        id: 2164261429,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Radiaux',
        placement: 'MenuBar',
        name: 'Radiaux',
    },
    {
        id: 2164261430,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Saisons',
        placement: 'MenuBar',
        name: 'Saisons',
    },
    {
        id: 2164261431,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Spectres',
        placement: 'MenuBar',
        name: 'Spectres',
    },
    {
        id: 2164261432,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Teintes',
        placement: 'MenuBar',
        name: 'Teintes',
    },
    {
        id: 2164261433,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Tons de chair',
        placement: 'MenuBar',
        name: 'Tons de chair',
    },
    {
        id: 2164261434,
        label: 'Fenêtre > Bibliothèques de nuances > Dégradés > Vignettes',
        placement: 'MenuBar',
        name: 'Vignettes',
    },
    {
        id: 2164261435,
        label: 'Fenêtre > Bibliothèques de nuances > Entreprise',
        placement: 'MenuBar',
        name: 'Entreprise',
    },
    {
        id: 2164261436,
        label: 'Fenêtre > Bibliothèques de nuances > Festivités',
        placement: 'MenuBar',
        name: 'Festivités',
    },
    {
        id: 2164261438,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Affiche russe',
        placement: 'MenuBar',
        name: 'Affiche russe',
    },
    {
        id: 2164261439,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Antique',
        placement: 'MenuBar',
        name: 'Antique',
    },
    {
        id: 2164261440,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Baroque',
        placement: 'MenuBar',
        name: 'Baroque',
    },
    {
        id: 2164261441,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Impressionisme',
        placement: 'MenuBar',
        name: 'Impressionisme',
    },
    {
        id: 2164261442,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Moyen Age',
        placement: 'MenuBar',
        name: 'Moyen Age',
    },
    {
        id: 2164261443,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Pop Art',
        placement: 'MenuBar',
        name: 'Pop Art',
    },
    {
        id: 2164261444,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Préhistorique',
        placement: 'MenuBar',
        name: 'Préhistorique',
    },
    {
        id: 2164261445,
        label: 'Fenêtre > Bibliothèques de nuances > Historique artistique > Renaissance',
        placement: 'MenuBar',
        name: 'Renaissance',
    },
    {
        id: 2164261446,
        label: 'Fenêtre > Bibliothèques de nuances > Métaux',
        placement: 'MenuBar',
        name: 'Métaux',
    },
    {
        id: 2164261447,
        label: 'Fenêtre > Bibliothèques de nuances > Minérales',
        placement: 'MenuBar',
        name: 'Minérales',
    },
    {
        id: 2164261450,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Décoratif > Héritage décoratif',
        placement: 'MenuBar',
        name: 'Héritage décoratif',
    },
    {
        id: 2164261451,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Décoratif > Motifs Vonster',
        placement: 'MenuBar',
        name: 'Motifs Vonster',
    },
    {
        id: 2164261453,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Graphiques de base > Graphiques de base_Lignes',
        placement: 'MenuBar',
        name: 'Graphiques de base_Lignes',
    },
    {
        id: 2164261454,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Graphiques de base > Graphiques de base_Points',
        placement: 'MenuBar',
        name: 'Graphiques de base_Points',
    },
    {
        id: 2164261455,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Graphiques de base > Graphiques de base_Textures',
        placement: 'MenuBar',
        name: 'Graphiques de base_Textures',
    },
    {
        id: 2164261457,
        label: 'Fenêtre > Bibliothèques de nuances > Motifs > Nature > Nature_Feuillage',
        placement: 'MenuBar',
        name: 'Nature_Feuillage',
    },
    {
        id: 2164261458,
        label: "Fenêtre > Bibliothèques de nuances > Motifs > Nature > Nature_Peaux d'animaux",
        placement: 'MenuBar',
        name: "Nature_Peaux d'animaux",
    },
    {
        id: 2164261460,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Feuillage',
        placement: 'MenuBar',
        name: 'Feuillage',
    },
    {
        id: 2164261461,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Fleurs',
        placement: 'MenuBar',
        name: 'Fleurs',
    },
    {
        id: 2164261462,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Paysage',
        placement: 'MenuBar',
        name: 'Paysage',
    },
    {
        id: 2164261463,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Pierre et brique',
        placement: 'MenuBar',
        name: 'Pierre et brique',
    },
    {
        id: 2164261464,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Plage',
        placement: 'MenuBar',
        name: 'Plage',
    },
    {
        id: 2164261465,
        label: 'Fenêtre > Bibliothèques de nuances > Nature > Saisons',
        placement: 'MenuBar',
        name: 'Saisons',
    },
    {
        id: 2164261466,
        label: 'Fenêtre > Bibliothèques de nuances > Neutre',
        placement: 'MenuBar',
        name: 'Neutre',
    },
    {
        id: 2164261468,
        label: 'Fenêtre > Bibliothèques de nuances > Nuanciers par défaut > Impression',
        placement: 'MenuBar',
        name: 'Impression',
    },
    {
        id: 2164261469,
        label: 'Fenêtre > Bibliothèques de nuances > Nuanciers par défaut > Périphériques',
        placement: 'MenuBar',
        name: 'Périphériques',
    },
    {
        id: 2164261470,
        label: 'Fenêtre > Bibliothèques de nuances > Nuanciers par défaut > RVB de base',
        placement: 'MenuBar',
        name: 'RVB de base',
    },
    {
        id: 2164261471,
        label: 'Fenêtre > Bibliothèques de nuances > Nuanciers par défaut > Vidéo et Film',
        placement: 'MenuBar',
        name: 'Vidéo et Film',
    },
    {
        id: 2164261472,
        label: 'Fenêtre > Bibliothèques de nuances > Nuanciers par défaut > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261474,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur chaude',
        placement: 'MenuBar',
        name: 'Couleur chaude',
    },
    {
        id: 2164261475,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur claire',
        placement: 'MenuBar',
        name: 'Couleur claire',
    },
    {
        id: 2164261476,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur désaturée',
        placement: 'MenuBar',
        name: 'Couleur désaturée',
    },
    {
        id: 2164261477,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur douce',
        placement: 'MenuBar',
        name: 'Couleur douce',
    },
    {
        id: 2164261478,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur foncée',
        placement: 'MenuBar',
        name: 'Couleur foncée',
    },
    {
        id: 2164261479,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur froide',
        placement: 'MenuBar',
        name: 'Couleur froide',
    },
    {
        id: 2164261480,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur saturée',
        placement: 'MenuBar',
        name: 'Couleur saturée',
    },
    {
        id: 2164261481,
        label: 'Fenêtre > Bibliothèques de nuances > Propriétés des couleurs > Couleur vive',
        placement: 'MenuBar',
        name: 'Couleur vive',
    },
    {
        id: 2164261483,
        label: 'Fenêtre > Bibliothèques de nuances > Scientifique > Analogues',
        placement: 'MenuBar',
        name: 'Analogues',
    },
    {
        id: 2164261484,
        label: 'Fenêtre > Bibliothèques de nuances > Scientifique > Complémentaires partagées',
        placement: 'MenuBar',
        name: 'Complémentaires partagées',
    },
    {
        id: 2164261485,
        label: 'Fenêtre > Bibliothèques de nuances > Scientifique > Complémentaires',
        placement: 'MenuBar',
        name: 'Complémentaires',
    },
    {
        id: 2164261486,
        label: 'Fenêtre > Bibliothèques de nuances > Scientifique > Tétradiques',
        placement: 'MenuBar',
        name: 'Tétradiques',
    },
    {
        id: 2164261487,
        label: 'Fenêtre > Bibliothèques de nuances > Scientifique > Triadiques',
        placement: 'MenuBar',
        name: 'Triadiques',
    },
    {
        id: 2164261488,
        label: 'Fenêtre > Bibliothèques de nuances > Système (Macintosh)',
        placement: 'MenuBar',
        name: 'Système (Macintosh)',
    },
    {
        id: 2164261489,
        label: 'Fenêtre > Bibliothèques de nuances > Système (Windows)',
        placement: 'MenuBar',
        name: 'Système (Windows)',
    },
    {
        id: 2164261490,
        label: 'Fenêtre > Bibliothèques de nuances > Textiles',
        placement: 'MenuBar',
        name: 'Textiles',
    },
    {
        id: 2164261491,
        label: 'Fenêtre > Bibliothèques de nuances > Tons de chair',
        placement: 'MenuBar',
        name: 'Tons de chair',
    },
    {
        id: 2164261492,
        label: 'Fenêtre > Bibliothèques de nuances > VisiBone2',
        placement: 'MenuBar',
        name: 'VisiBone2',
    },
    {
        id: 2164261493,
        label: 'Fenêtre > Bibliothèques de nuances > Web',
        placement: 'MenuBar',
        name: 'Web',
    },
    {
        id: 2164261496,
        label: 'Fenêtre > Bibliothèques de nuances > Autre bibliothèque...',
        placement: 'MenuBar',
        name: 'Autre bibliothèque...',
    },
    {
        id: 2164261497,
        label: 'Fenêtre > Guide des couleurs',
        placement: 'MenuBar',
        name: 'Guide des couleurs',
    },
    {
        id: 2164261498,
        label: "Edition > Modifier les couleurs > Redéfinir les couleurs de l'illustration...",
        placement: 'MenuBar',
        name: "Redéfinir les couleurs de l'illustration...",
    },
    {
        id: 2164261501,
        label: 'Edition > Modifier les couleurs > Recoloration générative',
        placement: 'MenuBar',
        name: 'Recoloration générative',
    },
    {
        id: 2164261503,
        label: 'Edition > Modifier les couleurs > Redéfinir les couleurs avec paramètre prédéfini > Bibliothèque de couleurs...',
        placement: 'MenuBar',
        name: 'Bibliothèque de couleurs...',
    },
    {
        id: 2164261504,
        label: 'Edition > Modifier les couleurs > Redéfinir les couleurs avec paramètre prédéfini > Couleur unique',
        placement: 'MenuBar',
        name: 'Couleur unique',
    },
    {
        id: 2164261505,
        label: 'Edition > Modifier les couleurs > Redéfinir les couleurs avec paramètre prédéfini > Deux couleurs',
        placement: 'MenuBar',
        name: 'Deux couleurs',
    },
    {
        id: 2164261506,
        label: 'Edition > Modifier les couleurs > Redéfinir les couleurs avec paramètre prédéfini > Trois couleurs',
        placement: 'MenuBar',
        name: 'Trois couleurs',
    },
    {
        id: 2164261507,
        label: 'Edition > Modifier les couleurs > Redéfinir les couleurs avec paramètre prédéfini > Harmonie de couleurs',
        placement: 'MenuBar',
        name: 'Harmonie de couleurs',
    },
    {
        id: 2164261508,
        label: 'Fenêtre > Contrôle',
        placement: 'MenuBar',
        name: 'Contrôle',
    },
    {
        id: 2164261509,
        label: 'Fenêtre > Barre des tâches contextuelle',
        placement: 'MenuBar',
        name: 'Barre des tâches contextuelle',
    },
    {
        id: 2164261511,
        label: 'Objet > Entrelacement > Créer',
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261512,
        label: 'Objet > Entrelacement > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261513,
        label: 'Objet > Entrelacement > Modifier',
        placement: 'MenuBar',
        name: 'Modifier',
    },
    {
        id: 2164261514,
        label: 'Fenêtre > Alignement',
        placement: 'MenuBar',
        name: 'Alignement',
    },
    {
        id: 2164261516,
        label: 'Objet > Alignement > Alignement horizontal à gauche',
        placement: 'MenuBar',
        name: 'Alignement horizontal à gauche',
    },
    {
        id: 2164261517,
        label: 'Objet > Alignement > Alignement horizontal au centre',
        placement: 'MenuBar',
        name: 'Alignement horizontal au centre',
    },
    {
        id: 2164261518,
        label: 'Objet > Alignement > Alignement horizontal à droite',
        placement: 'MenuBar',
        name: 'Alignement horizontal à droite',
    },
    {
        id: 2164261519,
        label: 'Objet > Alignement > Alignement vertical en haut',
        placement: 'MenuBar',
        name: 'Alignement vertical en haut',
    },
    {
        id: 2164261520,
        label: 'Objet > Alignement > Alignement vertical au centre',
        placement: 'MenuBar',
        name: 'Alignement vertical au centre',
    },
    {
        id: 2164261521,
        label: 'Objet > Alignement > Alignement vertical en bas',
        placement: 'MenuBar',
        name: 'Alignement vertical en bas',
    },
    {
        id: 2164261523,
        label: 'Objet > Répartition > Distribution verticale depuis le haut',
        placement: 'MenuBar',
        name: 'Distribution verticale depuis le haut',
    },
    {
        id: 2164261524,
        label: 'Objet > Répartition > Distribution verticale depuis le centre',
        placement: 'MenuBar',
        name: 'Distribution verticale depuis le centre',
    },
    {
        id: 2164261525,
        label: 'Objet > Répartition > Distribution verticale depuis le bas',
        placement: 'MenuBar',
        name: 'Distribution verticale depuis le bas',
    },
    {
        id: 2164261526,
        label: 'Objet > Répartition > Distribution horizontale à gauche',
        placement: 'MenuBar',
        name: 'Distribution horizontale à gauche',
    },
    {
        id: 2164261527,
        label: 'Objet > Répartition > Distribution horizontale au centre',
        placement: 'MenuBar',
        name: 'Distribution horizontale au centre',
    },
    {
        id: 2164261528,
        label: 'Objet > Répartition > Distribution horizontale à droite',
        placement: 'MenuBar',
        name: 'Distribution horizontale à droite',
    },
    {
        id: 2164261529,
        label: 'Fenêtre > Transformation',
        placement: 'MenuBar',
        name: 'Transformation',
    },
    {
        id: 2164261530,
        label: "Affichage > Widget Masquer l'angle",
        placement: 'MenuBar',
        name: "Widget Masquer l'angle",
    },
    {
        id: 2164261532,
        label: 'Objet > Répéter > Radial',
        placement: 'MenuBar',
        name: 'Radial',
    },
    {
        id: 2164261533,
        label: 'Objet > Répéter > Grille',
        placement: 'MenuBar',
        name: 'Grille',
    },
    {
        id: 2164261534,
        label: 'Objet > Répéter > Miroir',
        placement: 'MenuBar',
        name: 'Miroir',
    },
    {
        id: 2164261536,
        label: 'Objet > Répéter > Annuler',
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261537,
        label: 'Objet > Répéter > Options...',
        placement: 'MenuBar',
        name: 'Options...',
    },
    {
        id: 2164261539,
        label: 'Objet > Objets curvilignes > Joindre...',
        placement: 'MenuBar',
        name: 'Joindre...',
    },
    {
        id: 2164261540,
        label: 'Objet > Objets curvilignes > Options...',
        placement: 'MenuBar',
        name: 'Options...',
    },
    {
        id: 2164261541,
        label: 'Objet > Objets curvilignes > Dilater',
        placement: 'MenuBar',
        name: 'Dilater',
    },
    {
        id: 2164261542,
        label: 'Effet > Tracé > Vectoriser le contour',
        placement: 'MenuBar',
        name: 'Vectoriser le contour',
    },
    {
        id: 2164261543,
        label: 'Effet > Tracé > Décalage...',
        placement: 'MenuBar',
        name: 'Décalage...',
    },
    {
        id: 2164261544,
        label: 'Objet > Tracé > Vectoriser le contour',
        placement: 'MenuBar',
        name: 'Vectoriser le contour',
    },
    {
        id: 2164261545,
        label: 'Objet > Tracé > Décalage...',
        placement: 'MenuBar',
        name: 'Décalage...',
    },
    {
        id: 2164261547,
        label: "Fenêtre > Barres d'outils > De base",
        placement: 'MenuBar',
        name: 'De base',
    },
    {
        id: 2164261548,
        label: "Fenêtre > Barres d'outils > Avancé",
        placement: 'MenuBar',
        name: 'Avancé',
    },
    {
        id: 2164261549,
        label: "Fenêtre > Barres d'outils > Getting Started",
        placement: 'MenuBar',
        name: 'Getting Started',
    },
    {
        id: 2164261551,
        label: "Fenêtre > Barres d'outils > Nouvelle barre d'outils...",
        placement: 'MenuBar',
        name: "Nouvelle barre d'outils...",
    },
    {
        id: 2164261552,
        label: "Fenêtre > Barres d'outils > Gérer les barres d'outils...",
        placement: 'MenuBar',
        name: "Gérer les barres d'outils...",
    },
    {
        id: 2164261553,
        label: "Fenêtre > Options d'objet",
        placement: 'MenuBar',
        name: "Options d'objet",
    },
    {
        id: 2164261554,
        label: 'Texte > Plus sur Adobe Fonts...',
        placement: 'MenuBar',
        name: 'Plus sur Adobe Fonts...',
    },
    {
        id: 2164261555,
        label: 'Texte > Résoudre les problèmes de polices manquantes...',
        placement: 'MenuBar',
        name: 'Résoudre les problèmes de polices manquantes...',
    },
    {
        id: 2164261556,
        label: 'Aide > Communauté d’assistance',
        placement: 'MenuBar',
        name: 'Communauté d’assistance',
    },
    {
        id: 2164261557,
        label: 'Aide > Soumettre le bogue/Demande de fonctionnalité...',
        placement: 'MenuBar',
        name: 'Soumettre le bogue/Demande de fonctionnalité...',
    },
    {
        id: 2164261559,
        label: 'Objet > Aligner sur la grille en pixels',
        placement: 'MenuBar',
        name: 'Aligner sur la grille en pixels',
    },
    {
        id: 2164261560,
        label: 'Fenêtre > Texte > Visionneuse Reflow',
        placement: 'MenuBar',
        name: 'Visionneuse Reflow',
    },
    {
        id: 2164261561,
        label: 'Aide > Consignes d’utilisation de l’IA générative',
        placement: 'MenuBar',
        name: 'Consignes d’utilisation de l’IA générative',
    },
    {
        id: 2164261563,
        label: 'Edition > Impressions prédéfinies...',
        placement: 'MenuBar',
        name: 'Impressions prédéfinies...',
    },
    {
        id: 2164261565,
        label: 'Fichier > Imprimer...',
        placement: 'MenuBar',
        name: 'Imprimer...',
    },
    {
        id: 2164261566,
        label: 'Edition > Aplatissements prédéfinis des transparences...',
        placement: 'MenuBar',
        name: 'Aplatissements prédéfinis des transparences...',
    },
    {
        id: 2164261567,
        label: 'Objet > Aplatissement des transparences...',
        placement: 'MenuBar',
        name: 'Aplatissement des transparences...',
    },
    {
        id: 2164261569,
        label: 'Objet > Forme > Convertir en forme',
        placement: 'MenuBar',
        name: 'Convertir en forme',
    },
    {
        id: 2164261570,
        label: 'Objet > Forme > Décomposer la forme',
        placement: 'MenuBar',
        name: 'Décomposer la forme',
    },
    {
        id: 2164261571,
        label: 'Fenêtre > Maquette',
        placement: 'MenuBar',
        name: 'Maquette',
    },
    {
        id: 2164261572,
        label: 'Fenêtre > Variantes générées',
        placement: 'MenuBar',
        name: 'Variantes générées',
    },
    {
        id: 2164261573,
        label: 'Objet > Générer des vecteurs (Beta)...',
        placement: 'MenuBar',
        name: 'Générer des vecteurs (Beta)...',
    },
    {
        id: 2164261574,
        label: 'Fichier > Générer des vecteurs (Beta)...',
        placement: 'MenuBar',
        name: 'Générer des vecteurs (Beta)...',
    },
    {
        id: 2164261575,
        label: 'Objet > Remplissage génératif de la forme (Beta)...',
        placement: 'MenuBar',
        name: 'Remplissage génératif de la forme (Beta)...',
    },
    {
        id: 2164261576,
        label: 'Fenêtre > 3D et matières',
        placement: 'MenuBar',
        name: '3D et matières',
    },
    {
        id: 2164261578,
        label: 'Objet > Perspective > Joindre au plan actif',
        placement: 'MenuBar',
        name: 'Joindre au plan actif',
    },
    {
        id: 2164261579,
        label: 'Objet > Perspective > Annuler la perspective',
        placement: 'MenuBar',
        name: 'Annuler la perspective',
    },
    {
        id: 2164261580,
        label: "Objet > Perspective > Déplacer le plan pour qu'il corresponde à l'objet",
        placement: 'MenuBar',
        name: "Déplacer le plan pour qu'il corresponde à l'objet",
    },
    {
        id: 2164261581,
        label: 'Objet > Perspective > Modifier le texte',
        placement: 'MenuBar',
        name: 'Modifier le texte',
    },
    {
        id: 2164261582,
        label: 'Edition > Paramètres prédéfinis de la grille...',
        placement: 'MenuBar',
        name: 'Paramètres prédéfinis de la grille...',
    },
    {
        id: 2164261585,
        label: 'Affichage > Grille de perspective > Afficher la grille',
        placement: 'MenuBar',
        name: 'Afficher la grille',
    },
    {
        id: 2164261586,
        label: 'Affichage > Grille de perspective > Afficher les règles',
        placement: 'MenuBar',
        name: 'Afficher les règles',
    },
    {
        id: 2164261587,
        label: 'Affichage > Grille de perspective > Magnétisme de la grille',
        placement: 'MenuBar',
        name: 'Magnétisme de la grille',
    },
    {
        id: 2164261588,
        label: 'Affichage > Grille de perspective > Verrouiller la grille',
        placement: 'MenuBar',
        name: 'Verrouiller la grille',
    },
    {
        id: 2164261589,
        label: 'Affichage > Grille de perspective > Verrouiller la position',
        placement: 'MenuBar',
        name: 'Verrouiller la position',
    },
    {
        id: 2164261591,
        label: 'Affichage > Grille de perspective > Définir la grille...',
        placement: 'MenuBar',
        name: 'Définir la grille...',
    },
    {
        id: 2164261597,
        label: 'Affichage > Grille de perspective > Enregistrer la grille en tant que paramètre prédéfini...',
        placement: 'MenuBar',
        name: 'Enregistrer la grille en tant que paramètre prédéfini...',
    },
    {
        id: 2164261598,
        label: "Fenêtre > Vectorisation de l'image",
        placement: 'MenuBar',
        name: "Vectorisation de l'image",
    },
    {
        id: 2164261600,
        label: "Objet > Vectorisation de l'image > Créer",
        placement: 'MenuBar',
        name: 'Créer',
    },
    {
        id: 2164261601,
        label: "Objet > Vectorisation de l'image > Créer et décomposer",
        placement: 'MenuBar',
        name: 'Créer et décomposer',
    },
    {
        id: 2164261602,
        label: "Objet > Vectorisation de l'image > Annuler",
        placement: 'MenuBar',
        name: 'Annuler',
    },
    {
        id: 2164261604,
        label: "Objet > Vectorisation de l'image > Décomposer",
        placement: 'MenuBar',
        name: 'Décomposer',
    },
    {
        id: 2164261605,
        label: 'Effet > Atténuation > Flou gaussien...',
        placement: 'MenuBar',
        name: 'Flou gaussien...',
    },
    {
        id: 2164261606,
        label: 'Edition > Paramètres prédéfinis Adobe PDF...',
        placement: 'MenuBar',
        name: 'Paramètres prédéfinis Adobe PDF...',
    },
    {
        id: 2164261607,
        label: 'Fenêtre > Exportation de ressources',
        placement: 'MenuBar',
        name: 'Exportation de ressources',
    },
    {
        id: 2164261608,
        label: 'Fichier > Inviter à modifier...',
        placement: 'MenuBar',
        name: 'Inviter à modifier...',
    },
    {
        id: 2164261609,
        label: 'Fichier > Partager pour révision…',
        placement: 'MenuBar',
        name: 'Partager pour révision…',
    },
    {
        id: 2164261610,
        label: 'Affichage > Grille de perspective > Perspective à un point > [Affichage normal-1P]',
        placement: 'MenuBar',
        name: '[Affichage normal-1P]',
    },
    {
        id: 2164261611,
        label: 'Affichage > Grille de perspective > Perspective à deux points > [Affichage normal-2P]',
        placement: 'MenuBar',
        name: '[Affichage normal-2P]',
    },
    {
        id: 2164261612,
        label: 'Affichage > Grille de perspective > Perspective à trois points > [Affichage normal-3P]',
        placement: 'MenuBar',
        name: '[Affichage normal-3P]',
    },
    {
        id: 2164261615,
        label: 'Fenêtre > Extensions > Bibliothèques',
        placement: 'MenuBar',
        name: 'Bibliothèques',
    },
    {
        id: 2164261616,
        label: 'Fenêtre > Historique des versions',
        placement: 'MenuBar',
        name: 'Historique des versions',
    },
    {
        id: 2164261617,
        label: 'Fichier > Historique des versions',
        placement: 'MenuBar',
        name: 'Historique des versions',
    },
    {
        id: 2164261618,
        label: 'Fenêtre > Commentaires',
        placement: 'MenuBar',
        name: 'Commentaires',
    },
    {
        id: 'Adobe Scroll Tool',
        label: 'Outil Main',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pen Tool',
        label: 'Outil Plume',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scale Tool',
        label: "Outil Mise à l'échelle",
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Tool',
        label: 'Outil Rotation',
        placement: 'Tool',
    },
    {
        id: 'Adobe Reflect Tool',
        label: 'Outil Miroir',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shear Tool',
        label: 'Outil Déformation',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scissors Tool',
        label: 'Outil Ciseaux',
        placement: 'Tool',
    },
    {
        id: 'Adobe Measure Tool',
        label: 'Outil Mesure',
        placement: 'Tool',
    },
    {
        id: 'Adobe Page Tool',
        label: "Outil Limites d'impression",
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Object Select Tool',
        label: 'Outil Sélection directe progressive',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Select Tool',
        label: 'Outil Sélection directe',
        placement: 'Tool',
    },
    {
        id: 'Adobe Select Tool',
        label: 'Outil Sélection',
        placement: 'Tool',
    },
    {
        id: 'Adobe Zoom Tool',
        label: 'Outil Zoom',
        placement: 'Tool',
    },
    {
        id: 'Adobe Add Anchor Point Tool',
        label: "Outil Ajout de point d'ancrage",
        placement: 'Tool',
    },
    {
        id: 'Adobe Delete Anchor Point Tool',
        label: "Outil Suppression de point d'ancrage",
        placement: 'Tool',
    },
    {
        id: 'Adobe Anchor Point Tool',
        label: "Outil Point d'ancrage",
        placement: 'Tool',
    },
    {
        id: 'Adobe Column Graph Tool',
        label: 'Outil Graphe à barres verticales',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Column Graph Tool',
        label: 'Outil Graphe à barres verticales empilées',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Graph Tool',
        label: 'Outil Graphe linéaire',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pie Graph Tool',
        label: 'Outil Graphe sectoriel',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Graph Tool',
        label: 'Outil Graphe à couches',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scatter Graph Tool',
        label: 'Outil Graphe à nuages de points',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bar Graph Tool',
        label: 'Outil Graphe à barres horizontales',
        placement: 'Tool',
    },
    {
        id: 'Adobe Stacked Bar Graph Tool',
        label: 'Outil Graphe à barres horizontales empilées',
        placement: 'Tool',
    },
    {
        id: 'Adobe Radar Graph Tool',
        label: 'Outil Graphe Radar',
        placement: 'Tool',
    },
    {
        id: 'Adobe Mesh Editing Tool',
        label: 'Outil Filet',
        placement: 'Tool',
    },
    {
        id: 'Adobe Type Tool',
        label: 'Outil Texte',
        placement: 'Tool',
    },
    {
        id: 'Adobe Area Type Tool',
        label: 'Outil Texte captif',
        placement: 'Tool',
    },
    {
        id: 'Adobe Path Type Tool',
        label: 'Outil Texte curviligne',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Type Tool',
        label: 'Outil Texte vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Area Type Tool',
        label: 'Outil Texte captif vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Vertical Path Type Tool',
        label: 'Outil Texte curviligne vertical',
        placement: 'Tool',
    },
    {
        id: 'Adobe Touch Type Tool',
        label: 'Outil Retouche de texte',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Builder Tool',
        label: 'Outil Concepteur de forme',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Paintbucket Tool',
        label: 'Pot de peinture dynamique',
        placement: 'Tool',
    },
    {
        id: 'Adobe Planar Face Select Tool',
        label: 'Outil Sélection de peinture dynamique',
        placement: 'Tool',
    },
    {
        id: 'Perspective Grid Tool',
        label: 'Outil Grille de perspective',
        placement: 'Tool',
    },
    {
        id: 'Perspective Selection Tool',
        label: 'Outil de sélection de perspective',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blend Tool',
        label: 'Outil Dégradé de formes',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Tool',
        label: 'Outil Tranche',
        placement: 'Tool',
    },
    {
        id: 'Adobe Slice Select Tool',
        label: 'Outil Sélection de tranche',
        placement: 'Tool',
    },
    {
        id: 'Adobe Direct Lasso Tool',
        label: 'Outil Lasso',
        placement: 'Tool',
    },
    {
        id: 'Adobe Crop Tool',
        label: 'Plan de travail',
        placement: 'Tool',
    },
    {
        id: 'Adobe Curvature Tool',
        label: 'Outil Courbure',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shaper Tool',
        label: 'Outil Shaper',
        placement: 'Tool',
    },
    {
        id: 'Adobe Puppet Warp Tool',
        label: 'Outil Déformation de la marionnette',
        placement: 'Tool',
    },
    {
        id: 'Adobe Magic Wand Tool',
        label: 'Outil Baguette magique',
        placement: 'Tool',
    },
    {
        id: 'Adobe Knife Tool',
        label: 'Outil Cutter',
        placement: 'Tool',
    },
    {
        id: 'Adobe Flare Tool',
        label: 'Outil Halo',
        placement: 'Tool',
    },
    {
        id: 'Adobe Free Transform Tool',
        label: 'Outil Transformation manuelle',
        placement: 'Tool',
    },
    {
        id: 'Adobe Line Tool',
        label: 'Outil Trait',
        placement: 'Tool',
    },
    {
        id: 'Adobe Arc Tool',
        label: 'Outil Arc',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangular Grid Tool',
        label: 'Outil Grille rectangulaire',
        placement: 'Tool',
    },
    {
        id: 'Adobe Polar Grid Tool',
        label: 'Outil Grille à coordonnées polaires',
        placement: 'Tool',
    },
    {
        id: 'Adobe Warp Tool',
        label: 'Outil Déformation',
        placement: 'Tool',
    },
    {
        id: 'Adobe New Twirl Tool',
        label: 'Outil Tourbillon',
        placement: 'Tool',
    },
    {
        id: 'Adobe Pucker Tool',
        label: 'Outil Contraction',
        placement: 'Tool',
    },
    {
        id: 'Adobe Bloat Tool',
        label: 'Outil Dilatation',
        placement: 'Tool',
    },
    {
        id: 'Adobe Scallop Tool',
        label: 'Outil Festons',
        placement: 'Tool',
    },
    {
        id: 'Adobe Cyrstallize Tool',
        label: 'Outil Cristallisation',
        placement: 'Tool',
    },
    {
        id: 'Adobe Wrinkle Tool',
        label: 'Outil Fronces',
        placement: 'Tool',
    },
    {
        id: 'Adobe Quick Pen Tool',
        label: 'Outil Plume rapide',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Tool',
        label: 'Outil Crayon',
        placement: 'Tool',
    },
    {
        id: 'Adobe Brush Tool',
        label: 'Outil Pinceau',
        placement: 'Tool',
    },
    {
        id: 'Adobe Blob Brush Tool',
        label: 'Outil Forme de tache',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Smooth Tool',
        label: 'Outil Arrondi',
        placement: 'Tool',
    },
    {
        id: 'Adobe Freehand Erase Tool',
        label: 'Outil Gomme',
        placement: 'Tool',
    },
    {
        id: 'Adobe Corner Join Tool',
        label: 'Outil Jonction',
        placement: 'Tool',
    },
    {
        id: 'Adobe Ellipse Shape Tool',
        label: 'Outil Ellipse',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Regular Polygon Tool',
        label: 'Outil Polygone',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Star Tool',
        label: 'Outil Etoile',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rectangle Shape Tool',
        label: 'Outil Rectangle',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rounded Rectangle Tool',
        label: 'Outil Rectangle arrondi',
        placement: 'Tool',
    },
    {
        id: 'Adobe Shape Construction Spiral Tool',
        label: 'Outil Spirale',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sprayer Tool',
        label: 'Outil Pulvérisation de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Shifter Tool',
        label: 'Outil Glissement de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Scruncher Tool',
        label: 'Outil Espacement de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Sizer Tool',
        label: 'Outil Redimensionnement de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Spinner Tool',
        label: 'Outil Rotation de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Stainer Tool',
        label: 'Outil Coloration de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Screener Tool',
        label: 'Outil Transparence de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Symbol Styler Tool',
        label: 'Outil Stylisation de symboles',
        placement: 'Tool',
    },
    {
        id: 'Adobe Gradient Vector Tool',
        label: 'Outil Dégradé de couleurs',
        placement: 'Tool',
    },
    {
        id: 'Adobe Dimension Tool',
        label: 'Outil Cote',
        placement: 'Tool',
    },
    {
        id: 'Adobe Constraints Tool',
        label: 'Objets curvilignes',
        placement: 'Tool',
    },
    {
        id: 'Adobe Rotate Canvas Tool',
        label: "Outil Rotation de l'affichage",
        placement: 'Tool',
    },
    {
        id: 'Adobe Reshape Tool',
        label: 'Outil Modelage',
        placement: 'Tool',
    },
    {
        id: 'Adobe Width Tool',
        label: 'Outil Largeur',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eraser Tool',
        label: 'Outil Gomme',
        placement: 'Tool',
    },
    {
        id: 'Adobe Eyedropper Tool',
        label: 'Outil Pipette',
        placement: 'Tool',
    },
    {
        id: '3D and Materials',
        label: '3D et matières',
        placement: 'Panel',
    },
    {
        id: 'Actions',
        label: "Scripts d'action",
        placement: 'Panel',
    },
    {
        id: 'AdobeAltGlyphsPanel',
        label: 'Glyphes',
        placement: 'Panel',
    },
    {
        id: 'AdobeBrush',
        label: 'Formes',
        placement: 'Panel',
    },
    {
        id: 'AdobeCharStyles',
        label: 'Styles de caractère',
        placement: 'Panel',
    },
    {
        id: 'AdobeColorGuidePanel',
        label: 'Guide des couleurs',
        placement: 'Panel',
    },
    {
        id: 'AdobeFlatteningPreview',
        label: "Aperçu de l'aplatissement",
        placement: 'Panel',
    },
    {
        id: 'AdobeGradientEditor',
        label: 'Dégradé',
        placement: 'Panel',
    },
    {
        id: 'AdobeHorizontalTabPanel',
        label: 'Tabulations',
        placement: 'Panel',
    },
    {
        id: 'AdobeLayerPalette',
        label: 'Calques',
        placement: 'Panel',
    },
    {
        id: 'AdobeObjectAttributes',
        label: "Options d'objet",
        placement: 'Panel',
    },
    {
        id: 'AdobeOpenTypeFont',
        label: 'OpenType',
        placement: 'Panel',
    },
    {
        id: 'AdobeParaStyles',
        label: 'Styles de paragraphe',
        placement: 'Panel',
    },
    {
        id: 'AdobePropertiesPanel',
        label: 'Propriétés',
        placement: 'Panel',
    },
    {
        id: 'AdobeSeparationPreview',
        label: 'Aperçu des séparations',
        placement: 'Panel',
    },
    {
        id: 'AdobeSwatch_',
        label: 'Nuancier',
        placement: 'Panel',
    },
    {
        id: 'AdobeVariablesPanel',
        label: 'Variables',
        placement: 'Panel',
    },
    {
        id: 'AdobeVerticalTabPanel',
        label: 'Tabulations',
        placement: 'Panel',
    },
    {
        id: 'Align',
        label: 'Alignement',
        placement: 'Panel',
    },
    {
        id: 'Appearance',
        label: 'Aspect',
        placement: 'Panel',
    },
    {
        id: 'Artboards',
        label: 'Plans de travail',
        placement: 'Panel',
    },
    {
        id: 'CCX Commenting UXP Webview',
        label: 'Commentaires',
        placement: 'Panel',
    },
    {
        id: 'CSS',
        label: 'Propriétés CSS (obsolète)',
        placement: 'Panel',
    },
    {
        id: 'CSXSExtension_com.adobe.DesignLibraries.angular_0',
        label: 'Bibliothèques',
        placement: 'Panel',
    },
    {
        id: 'Character',
        label: 'Caractère',
        placement: 'Panel',
    },
    {
        id: 'Color',
        label: 'Couleur',
        placement: 'Panel',
    },
    {
        id: 'Document Info',
        label: 'Informations sur le document',
        placement: 'Panel',
    },
    {
        id: 'Export',
        label: 'Exportation de ressources',
        placement: 'Panel',
    },
    {
        id: 'GeneratedVariations',
        label: 'Variantes générées',
        placement: 'Panel',
    },
    {
        id: 'History',
        label: 'Historique',
        placement: 'Panel',
    },
    {
        id: 'Info',
        label: 'Infos',
        placement: 'Panel',
    },
    {
        id: 'Links',
        label: 'Liens',
        placement: 'Panel',
    },
    {
        id: 'Magic Wand',
        label: 'Baguette magique',
        placement: 'Panel',
    },
    {
        id: 'Mockup',
        label: 'Maquette',
        placement: 'Panel',
    },
    {
        id: 'NamedStyle',
        label: 'Styles graphiques',
        placement: 'Panel',
    },
    {
        id: 'Navigator',
        label: 'Navigation',
        placement: 'Panel',
    },
    {
        id: 'Paragraph',
        label: 'Paragraphe',
        placement: 'Panel',
    },
    {
        id: 'Pathfinder',
        label: 'Pathfinder',
        placement: 'Panel',
    },
    {
        id: 'PatternOptionsPanel',
        label: 'Options de motif',
        placement: 'Panel',
    },
    {
        id: 'Reflow Viewer',
        label: 'Visionneuse Reflow',
        placement: 'Panel',
    },
    {
        id: 'Retype',
        label: 'Retype',
        placement: 'Panel',
    },
    {
        id: 'SVGInteractivity',
        label: 'Interactivité SVG',
        placement: 'Panel',
    },
    {
        id: 'Stroke',
        label: 'Contour',
        placement: 'Panel',
    },
    {
        id: 'Symbols',
        label: 'Symboles',
        placement: 'Panel',
    },
    {
        id: 'Transform',
        label: 'Transformation',
        placement: 'Panel',
    },
    {
        id: 'Transparency',
        label: 'Transparence',
        placement: 'Panel',
    },
    {
        id: 'Vectorize',
        label: "Vectorisation de l'image",
        placement: 'Panel',
    },
    {
        id: 'ccx-timeline',
        label: 'Historique des versions',
        placement: 'Panel',
    },
];
